webpackJsonp([0],{

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pdpAddToBag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_add_to_bag__ = __webpack_require__(37);


function showSizeError() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeError').fadeIn();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeErrorText').attr("role", "alert");
}
function hideFittingRoom() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name=tryon-size-options]').prop('checked', false);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#accordionTryOnItem").hide();
}
function getFitItemSizes() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name=tryon-size-options]:checked').val();
}
var pdpAddToBag = function pdpAddToBag($el, opts) {
  var code = opts.code ? opts.code : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#code').val();
  var size = opts.size ? opts.size : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeValue').val();
  var isOOSSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeValue').data('oosSize');
  var assignedSellableDefectItemSerialNumber = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#assignedSellableDefectItemSerialNumber').val();
  var isMens = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#header-jsp').data('department') === 'Mens';
  if (size === null || size === '') {
    showSizeError();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.size-options').focus();
  } else if (!isOOSSize) {
    if ($el) {
      $el.prop('disabled', true);
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('productAddedToBag');
    var fitItemsSelected = getFitItemSizes();
    if (fitItemsSelected && fitItemsSelected.trim().length) {
      hideFittingRoom();
    }
    var data = {
      productCode: code,
      size: size,
      sectionURL: window.rcProps.sectionUrl,
      sessionID: window.rcProps.sessionId,
      isMens: isMens,
      src: opts.src ? opts.src : 'addtobag',
      csrfHash: window.rcProps.csrfHash,
      useReferrer: true,
      isPopup: false,
      qvclick: window.rcProps.qvClick,
      hotlistQuickView: false,
      fitItemSizes: fitItemsSelected,
      serial: assignedSellableDefectItemSerialNumber,
      department: window.rcProps.pdp.department,
      cat1: window.rcProps.pdp.cat1
    };
    if ($el) {
      data.focusID = $el.attr('id');
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-counter-value").length) {
      data.count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-counter-value").text();
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#replenish-save').is(':checked')) {
      data.subscriptionInterval = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#subscription-interval option:selected').val();
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_add_to_bag__["a" /* addToBagWithData */])(data);
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeError').html(opts.oosText);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeError').css('display', 'block');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeError').delay(2000).fadeOut();
  }
};

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);


var PLUGIN_NAME = 'addBuyNow';
var showSizeError = function showSizeError() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeError').fadeIn();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeErrorText').attr("role", "alert");
};
var getFitItemSizes = function getFitItemSizes() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name=tryon-size-options]:checked').val();
};
var setEventListeners = function setEventListeners($el, opts) {
  $el.on('click', function () {
    var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#code').val();
    var size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeValue').val();
    if (size === null || size === '') {
      showSizeError();
    } else {
      var data = {
        source: 'buynow',
        bnCode: code,
        bnSize: size,
        sectionUrl: window.rcProps.sectionUrl,
        fittingRoomSize: getFitItemSizes()
      };
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#replenish-save').is(':checked')) {
        data.subscriptionInterval = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#subscription-interval option:selected').val();
      }
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-counter-value").length) {
        data.quantity = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-counter-value").text();
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('productBuyNow');
      addBuyNowProductWithData(data);
    }
  });
};
function addBuyNow(el, options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  setEventListeners($el, options);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, addBuyNow);

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__add_to_bag_function__ = __webpack_require__(104);




var PLUGIN_NAME = 'addToBag';
var DEFAULTS = {};
var setEventListeners = function setEventListeners($el, opts) {
  $el.on('click', function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__add_to_bag_function__["a" /* pdpAddToBag */])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), opts);
  });
};
function addToBag(el, options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, addToBag);

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Modular Chat Window jQuery Plugin
 */




 // Import the Keyboard module for trap focus

// Plugin name and default options
var PLUGIN_NAME = 'chatWindow';
var DEFAULTS = {
  chatButton: '.js-chat-window',
  chatWindowTarget: '.js-chat-window-target',
  chatWindowContent: '.ai-chat-window__content',
  chatWindowClose: '.js-chat-window-close',
  feedbackButton: '.js-switch-text-status',
  feedbackForm: '.js-chat-feedback-form',
  conversationContainer: '#js-chat-window-conversation',
  feedbackContainer: '#js-switch-text-target',
  feedbackButtonContainer: '#js-feedback-button-container',
  feedbackMessageContainer: '#js-submit-feedback-container',
  sizeguideBtnContainer: '#js-sizeguide-target',
  pendingContainer: undefined,
  // JQuery object set in logic
  responseContainer: undefined,
  // JQuery object set in logic
  suggestionsContainer: '#js-chat-window-suggestions',
  windowHeader: '.ai-chat-window__header',
  // Chat window header selector for a11y focus
  loadingText: 'Thinking',
  activeClass: 'is-active',
  hideClass: 'u-hide',
  messageClass: 'message',
  progressClass: 'ai-chat-window__content-progress',
  loadingIntervalId: null,
  // Will be set when animation is shown
  loadingDuration: 1500,
  loadingInterval: 500,
  maxDots: 3,
  maxSuggestions: 5,
  // Function references for keyboard focus management
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].trapFocus ? __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */]) : null,
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].releaseFocus ? __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */]) : null
};

/**
 * Sets focus to the chat window header for accessibility and traps focus inside the window
 * @param {Object} options - Options containing the window header selector
 */
function focusWindowHeader(options) {
  // Find the window header
  var $header = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.windowHeader);

  // If header exists, set focus to it
  if ($header.length) {
    // Set tabindex if it doesn't have one already
    if (!$header.attr('tabindex')) {
      $header.attr('tabindex', '-1');
    }

    // Small delay to ensure DOM is ready and transitions are complete
    setTimeout(function () {
      $header.focus();
      if (options.chatWindowTarget && options.trapFocusFunc) {
        // Use jQuery selector instead of vanilla DOM
        var $chatWindow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowTarget);
        if ($chatWindow.length) {
          options.trapFocusFunc($chatWindow);
        } else {
          console.warn('Chat window element not found:', options.chatWindowTarget);
        }
      }
    }, 100);
  }
}

/**
 * Opens the chat window and shows loading animation
 */
function openChatWindow($trigger, options) {
  var buttonText = $trigger.text();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ai-chat-window__content-progress').addClass('ai-chat-window__content-progress--disabled');

  // Store the trigger element for focus return when closing
  var $chatWindow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowTarget);
  $chatWindow.data('triggerElement', $trigger);

  // Hide & reset feedback element
  resetFeedback(options);

  // Hide suggestions based on what was asked previously, also display next one if any
  resetSuggestions($trigger, options);

  // Open chat window
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowTarget).addClass(options.activeClass);

  // Append question to window
  var question = $trigger.html();
  var $questionContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='ai-chat-window__content-question'></div>");
  $questionContainer.append("<div class='".concat(options.messageClass, "'><span>").concat(question, "</span></div>"));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.conversationContainer).append($questionContainer);
  var rank = $trigger.data('rank');
  var answerClass = 'answer_' + rank;
  var recommendationsClass = 'recom_' + rank;
  // Append loading container
  options.pendingContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div></div>");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.conversationContainer).append(options.pendingContainer);

  // Append response and suggestions if any
  var answerData = '';
  var showSizeguide = false;
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + answerClass).length > 0) {
    answerData = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + answerClass).html();
  } else {
    answerData = $trigger.data('answer');
    if ($trigger.data('sizeguide') == true && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.sizeguideBtnContainer).length) {
      answerData = answerData + '<br><br>' + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.sizeguideBtnContainer).html();
      showSizeguide = true;
    }
  }
  options.responseContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(options.hideClass, "'></div>"));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.conversationContainer).append(options.responseContainer);
  if (answerData && answerData.length > 0) {
    options.responseContainer.append("<div class='".concat(answerClass, "'>").concat(answerData, "</div>"));
  }
  if ($trigger.data('recommendationsUrl')) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + recommendationsClass).length > 0) {
      var $recommendationsContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(recommendationsClass, "'></div>"));
      options.responseContainer.append($recommendationsContainer);
      options.responseContainer.removeClass(options.hideClass);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.suggestionsContainer).show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackContainer).show();
      $recommendationsContainer.html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + recommendationsClass).first().html());
      scrollToQuestion();
    } else {
      var _$recommendationsContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(recommendationsClass, "'></div>"));
      options.responseContainer.append(_$recommendationsContainer);
      showLoadingAnimation(options);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get($trigger.data('recommendationsUrl'), function (data) {
        _$recommendationsContainer.html(data);
        stopLoadingAnimation(options);
        scrollToQuestion();
        carouselInit();
        if (showSizeguide == true) {
          bindSizeGuideButton();
        }
      });
    }
  }
  var $feedbackButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButton);
  $feedbackButton.data('question', buttonText.trim());
  $feedbackButton.data('answer', $trigger.data('answer'));
  $feedbackButton.data('position', $trigger.data('rank'));

  // Focus on the window header for accessibility and trap focus
  focusWindowHeader(options);
  if (!$trigger.data('recommendationsUrl')) {
    options.responseContainer.removeClass(options.hideClass);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.suggestionsContainer).show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackContainer).show();
    scrollToQuestion();
    carouselInit();
    if (showSizeguide == true) {
      bindSizeGuideButton();
    }
  }
  function scrollToQuestion() {
    // Scroll to the question container
    var $scrollableContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowContent);
    if ($scrollableContent.length && $questionContainer.length) {
      var scrollTop = $questionContainer.offset().top - $scrollableContent.offset().top + $scrollableContent.scrollTop();
      $scrollableContent.animate({
        scrollTop: scrollTop - 10
      }, 150);
    }
  }
}

/**
 * Displays loading animation with dots
 */
function showLoadingAnimation(options) {
  // Disable all previous loading animations by adding disabled class
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(options.progressClass)).not('.ai-chat-window__content-progress--disabled').addClass('ai-chat-window__content-progress--disabled');

  // Create loading element
  var $loadingMessage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(options.progressClass, "'>").concat(options.loadingText, "</div>"));
  options.pendingContainer.append($loadingMessage);

  // Store reference to loading message for external access
  options.loadingMessage = $loadingMessage;

  // Animate dots
  var dots = 0;
  options.loadingIntervalId = setInterval(function () {
    // Check if disabled class exists - if so, pause the animation
    if ($loadingMessage.hasClass('ai-chat-window__content-progress--disabled')) {
      return; // Skip this iteration, but keep interval running
    }
    dots = dots + 1 > options.maxDots ? 1 : dots + 1;
    $loadingMessage.text("".concat(options.loadingText).concat('.'.repeat(dots)));
  }, options.loadingInterval);
}
function stopLoadingAnimation(options) {
  // Show response after timeout
  clearInterval(options.loadingIntervalId);
  options.pendingContainer.remove();
  options.responseContainer.removeClass(options.hideClass);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.suggestionsContainer).show();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackContainer).show();
  options.pendingContainer = undefined;
  options.responseContainer = undefined;
}

/**
 * Closes the chat window
 */
function closeChatWindow(options) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowTarget).removeClass(options.activeClass);

  // Get the stored trigger element
  var $chatWindow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowTarget);
  var $triggerElement = $chatWindow.data('triggerElement');

  // Release focus trap from the element that had it trapped
  if (options.releaseFocusFunc && typeof options.releaseFocusFunc === 'function') {
    if ($chatWindow.length) {
      options.releaseFocusFunc($chatWindow);
    }
  }
  // Return focus to the trigger element

  if ($triggerElement && $triggerElement.length) {
    // Small delay to ensure the chat window is fully closed
    setTimeout(function () {
      $triggerElement.focus();
    }, 50);
  }

  // Clean up stored data
  $chatWindow.removeData('triggerElement');

  // Clear all responses and contents
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.conversationContainer).empty();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(options.suggestionsContainer, " ").concat(options.chatButton)).removeClass(options.hideClass).removeAttr('data-clicked');
}
function handleFeedbackButton($trigger, options) {
  // 1. Cache selectors and initial data
  var $feedbackContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackContainer);
  var $feedbackButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButton);
  var $feedbackForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackForm);
  var $suggestionsContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.suggestionsContainer);
  var isHelpful = $trigger.data('feedback') === 1;

  // 2. Helper: Reset UI State (Use classes instead of inline CSS if possible!)
  var resetUI = function resetUI() {
    $feedbackButton.prop('disabled', false).css({
      background: "",
      borderRadius: ""
    });
    $trigger.prop('disabled', true).css({
      background: '#e4e4e4',
      borderRadius: '50%'
    });
  };

  // 3. Helper: Final Transition (The "Thank You" sequence)
  var showSuccessState = function showSuccessState() {
    $feedbackContainer.fadeOut(500, function () {
      $trigger.prop('disabled', false);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButtonContainer).addClass('u-hide');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackMessageContainer).removeClass('u-hide');
      $feedbackContainer.fadeIn(500);
    });
  };

  // 4. Helper: Centralized Ajax Logic
  var sendFeedback = function sendFeedback(submissionData) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: $feedbackContainer.data('url'),
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(submissionData),
      success: function success() {
        resetFeedback(options);
        $suggestionsContainer.show();
        $feedbackForm.trigger("reset");
        if (!isHelpful) $feedbackForm.fadeOut(500).addClass('u-hide');
        showSuccessState();
      }
    });
  };

  // --- Execution Logic ---
  resetUI();

  // scroll to form similar
  function scrollToForm() {
    var $chatWindowContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowContent);
    var $feedbackForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackForm);
    var scrollTop = $feedbackForm.offset().top - $chatWindowContent.offset().top + $chatWindowContent.scrollTop();
    $chatWindowContent.animate({
      scrollTop: scrollTop - 10
    }, 150);
  }
  var data = {
    code: $feedbackContainer.data('code'),
    question: $trigger.data('question'),
    answer: $trigger.data('answer'),
    position: $trigger.data('position'),
    feedback: isHelpful ? 'Helpful' : 'Not Helpful'
  };
  if (!isHelpful) {
    // Show form and wait for submission
    $feedbackForm.fadeIn().removeClass('u-hide');

    // Hide questions
    $suggestionsContainer.hide();

    // Scroll to form
    scrollToForm();

    // Use .off() to ensure we don't stack multiple listeners
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off("submit", options.feedbackForm).on("submit", options.feedbackForm, function (e) {
      e.preventDefault();
      var formData = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).serializeArray();

      // Add the form data to our existing object
      sendFeedback(_objectSpread(_objectSpread({}, data), {}, {
        feedbackForm: formData
      }));
    });
  } else {
    $suggestionsContainer.show();
    // It is helpful: Hide form and send immediately
    $feedbackForm.hide();
    sendFeedback(data);
  }
}
function resetFeedback(options) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackContainer).hide();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButtonContainer).removeClass('u-hide');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackMessageContainer).addClass('u-hide');
  var $feedbackButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButton);
  $feedbackButton.prop('disabled', false).css({
    background: "",
    borderRadius: ""
  });
  $feedbackButton.data('question', '');
  $feedbackButton.data('answer', '');
  $feedbackButton.data('position', -1);
}
function resetSuggestions($trigger, options) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.suggestionsContainer).hide();
  var $suggestions = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(options.suggestionsContainer, " ").concat(options.chatButton));
  $suggestions.addClass(options.hideClass);

  // Mark clicked so it never reappears
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(options.suggestionsContainer, " ").concat(options.chatButton, "[data-rank='").concat($trigger.data('rank'), "']")).attr('data-clicked', '1');

  // Reveal next 5 suggestions if any
  var suggestionCount = 0;
  $suggestions.each(function () {
    var $suggestion = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (!$suggestion.attr('data-clicked') && suggestionCount < options.maxSuggestions) {
      $suggestion.removeClass(options.hideClass);
      suggestionCount++;
    }
  });
}

/**
 * Binds all event handlers
 */
function bindEventHandlers(options) {
  // Remove any previously bound events to prevent duplicates
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click.chatWindow', options.chatButton);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click.chatWindow', options.feedbackButton);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click.chatWindow', options.chatWindowClose);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('keydown.chatWindow');

  // Regular chat buttons (excluding "something else" buttons)
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.chatWindow', options.chatButton, function () {
    if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is(options.somethingElseButton)) {
      var buttonText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text();
      openChatWindow(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), options);
      logEngagementWithDetails(window.location.href, 'PDP_GenQA', 'click', buttonText.trim());
    }
  });

  // Feedback button handling
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.chatWindow', options.feedbackButton, function () {
    handleFeedbackButton(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), options);
  });

  // Chat window close button
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.chatWindow', options.chatWindowClose, function () {
    closeChatWindow(options);
  });

  // Handle escape key to close the chat window
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('keydown.chatWindow', function (e) {
    if (e.key === 'Escape' && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowTarget).hasClass(options.activeClass)) {
      closeChatWindow(options);
    }
  });
}

/**
 * Carousel 
 */
function carouselInit() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-carousel-recom-chat").slickSlider({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false
  });
}
function bindSizeGuideButton() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-sizeguide-gq').off('click').on('click', function () {
    showMeasurementGuide();
  });
}

/**
 * Main plugin initialization function
 */
function chatWindow(el) {
  var userOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);

  // Prevent multiple initializations
  if ($element.data(PLUGIN_NAME + 'Initialized')) {
    return $element;
  }

  // Merge default options with user options
  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, userOptions, $element);

  // Initialize a11y attributes
  initializeA11yAttributes(options);

  // Bind event handlers
  bindEventHandlers(options);

  // Mark as initialized
  $element.data(PLUGIN_NAME + 'Initialized', true);

  // Store options for later access
  $element.data(PLUGIN_NAME + 'Options', options);

  // Return element for chaining
  return $element;
}

/**
 * Sets up accessibility attributes on the chat window elements
 */
function initializeA11yAttributes(options) {
  // Set up header for accessibility
  var $header = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.windowHeader);
  if ($header.length) {
    // Ensure the header can receive focus
    if (!$header.attr('tabindex')) {
      $header.attr('tabindex', '-1');
    }

    // Add appropriate ARIA role and label if not present
    if (!$header.attr('role')) {
      $header.attr('role', 'dialog');
    }
    if (!$header.attr('aria-labelledby') && $header.find('h2, h3, h4').length) {
      var headingId = 'chat-window-heading';
      $header.find('h2, h3, h4').first().attr('id', headingId);
      $header.attr('aria-labelledby', headingId);
    } else if (!$header.attr('aria-label')) {
      $header.attr('aria-label', 'Chat Window');
    }
  }

  // Make close button accessible
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowClose).attr('aria-label', 'Close chat window');

  // Set appropriate ARIA attributes on the chat window
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowTarget).attr({
    'role': 'dialog',
    'aria-modal': 'true'
  });
}

// Register as jQuery plugin
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, chatWindow);

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getReviews;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

function getReviews(params, reviewPageNum, focusId) {
  var pdpData = window.rcProps.pdp || {};
  params = params || {};
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    prodCode: pdpData.code,
    bodyType: params.bodyType,
    heightType: params.heightType,
    rating: params.rating,
    productSize: params.productSize,
    productColor: params.productColor,
    reviewSort: params.sort,
    reviewPageNum: reviewPageNum
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: "/r/ajax/PDPCustomerReviews.jsp",
    data: data,
    success: function success(data) {
      var customerReviewMarkup = parseRtn(data);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-review-area').html(customerReviewMarkup);
      setEventListeners();
      // Dropdown Effect for Ajax Review Content
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-dropdown').dropdown();
    },
    complete: function complete() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + focusId).focus();
    }
  });
}
function setEventListeners() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-customer-reviews").on("click", function (e) {
    e.preventDefault();
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: el.data('modalUrl'),
      triggerOpen: true,
      type: "large",
      returnFocus: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)
    });
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[name='reviewByBodyType']").on("click", function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var params = {
      bodyType: el.val(),
      heightType: el.data('heightType'),
      rating: el.data('ratingType'),
      productSize: el.data('sizeValue'),
      productColor: el.data('colorValue'),
      sort: el.data('currentSort')
    };
    getReviews(params, 1, "body_type_filter");
    logEngagement(window.location.href, "PDP Reviews Main", params.bodyType + " Body Type Filter Selected");
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[name='reviewByHeight']").on("click", function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var params = {
      bodyType: el.data('bodyType'),
      heightType: el.val(),
      rating: el.data('ratingType'),
      productSize: el.data('sizeValue'),
      productColor: el.data('colorValue'),
      sort: el.data('currentSort')
    };
    getReviews(params, 1, "height_filter");
    logEngagement(window.location.href, "PDP Reviews Main", params.heightType + " Height Filter Selected");
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[name='review_sort_by']").on("click", function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var params = {
      bodyType: el.data('bodyType'),
      heightType: el.data('heightType'),
      rating: el.data('ratingType'),
      productSize: el.data('sizeValue'),
      productColor: el.data('colorValue'),
      sort: el.val()
    };
    getReviews(params, 1, "review_sort");
    logEngagement(window.location.href, "PDP Reviews Main", params.sort + " Selected");
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[name='reviewByRating']").on("click", function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var params = {
      bodyType: el.data('bodyType'),
      heightType: el.data('heightType'),
      rating: el.val(),
      productSize: el.data('sizeValue'),
      productColor: el.data('colorValue'),
      sort: el.data('currentSort')
    };
    getReviews(params, 1, "rating_filter");
    logEngagement(window.location.href, "PDP Reviews Main", params.ratingType + " Rating Filter Selected");
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[name='reviewBySize']").on("click", function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var params = {
      bodyType: el.data('bodyType'),
      heightType: el.data('heightType'),
      rating: el.data('ratingType'),
      productSize: el.val(),
      productColor: el.data('colorValue'),
      sort: el.data('currentSort')
    };
    getReviews(params, 1, "size_filter");
    logEngagement(window.location.href, "PDP Reviews Main", params.sizeType + " Size Filter Selected");
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[name='reviewByColor']").on("click", function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var params = {
      bodyType: el.data('bodyType'),
      heightType: el.data('heightType'),
      rating: el.data('ratingType'),
      productSize: el.data('sizeValue'),
      productColor: el.val(),
      sort: el.data('currentSort')
    };
    getReviews(params, 1, "color_filter");
    logEngagement(window.location.href, "PDP Reviews Main", params.colorType + " Color Filter Selected");
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-review-pagination").on("click", function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var page = el.data('page');
    var params = {
      bodyType: el.data('bodyType'),
      heightType: el.data('heightType'),
      rating: el.data('ratingType'),
      productSize: el.data('sizeValue'),
      productColor: el.data('colorValue'),
      sort: el.data('currentSort')
    };
    getReviews(params, page, el.attr("id"));
    logEngagement(window.location.href, page, 'Review page click');
  });
}

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
  var defaults = {
    url: false,
    callback: false,
    target: false,
    duration: 120,
    on: 'mouseover',
    // other options: grab, click, toggle, click-n-grab
    touch: true,
    // enables a touch fallback
    onZoomIn: false,
    onZoomOut: false,
    magnify: 1,
    moveDirection: 'standard' // NEW: 'standard' (default) or 'reverse'
  };

  // Core Zoom Logic, independent of event listeners.
  $.zoom = function (target, source, img, magnify, settings) {
    var targetHeight,
      targetWidth,
      sourceHeight,
      sourceWidth,
      xRatio,
      yRatio,
      offset,
      $target = $(target),
      position = $target.css('position'),
      $source = $(source);

    // The parent element needs positioning so that the zoomed element can be correctly positioned within.
    target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
    target.style.overflow = 'hidden';
    img.style.width = img.style.height = '';
    $(img).addClass('zoomImg').css({
      position: 'absolute',
      top: 0,
      left: 0,
      opacity: 0,
      width: img.width * magnify,
      height: img.height * magnify,
      border: 'none',
      maxWidth: 'none',
      maxHeight: 'none'
    }).appendTo(target);
    return {
      init: function init() {
        targetWidth = $target.outerWidth();
        targetHeight = $target.outerHeight();
        if (source === target) {
          sourceWidth = targetWidth;
          sourceHeight = targetHeight;
        } else {
          sourceWidth = $source.outerWidth();
          sourceHeight = $source.outerHeight();
        }
        xRatio = (img.width - targetWidth) / sourceWidth;
        yRatio = (img.height - targetHeight) / sourceHeight;
        offset = $source.offset();
      },
      move: function move(e) {
        var left = e.pageX - offset.left,
          top = e.pageY - offset.top;
        top = Math.max(Math.min(top, sourceHeight), 0);
        left = Math.max(Math.min(left, sourceWidth), 0);
        img.style.left = left * -xRatio + 'px';
        img.style.top = top * -yRatio + 'px';
      }
    };
  };
  $.fn.zoom = function (options) {
    return this.each(function () {
      var settings = $.extend({}, defaults, options || {}),
        //target will display the zoomed image
        target = settings.target && $(settings.target)[0] || this,
        //source will provide zoom location info (thumbnail)
        source = this,
        $source = $(source),
        img = document.createElement('img'),
        $img = $(img),
        mousemove = 'mousemove.zoom',
        clicked = false,
        touched = false;

      // If a url wasn't specified, look for an image element.
      if (!settings.url) {
        var srcElement = source.querySelector('img');
        if (srcElement) {
          settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
        }
        if (!settings.url) {
          return;
        }
      }
      $source.one('zoom.destroy', function (position, overflow) {
        $source.off(".zoom");
        target.style.position = position;
        target.style.overflow = overflow;
        img.onload = null;
        $img.remove();
      }.bind(this, target.style.position, target.style.overflow));
      img.onload = function () {
        // Modified: Pass 'settings' as the new fifth argument to $.zoom
        var zoom = $.zoom(target, source, img, settings.magnify, settings);
        function start(e) {
          zoom.init();
          zoom.move(e);

          // Skip the fade-in for IE8 and lower since it chokes on fading-in
          // and changing position based on mousemovement at the same time.
          $img.stop().fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
        }
        function stop() {
          $img.stop().fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
        }

        // Mouse events
        if (settings.on === 'grab') {
          $source.on('mousedown.zoom', function (e) {
            if (e.which === 1) {
              $(document).one('mouseup.zoom', function () {
                stop();
                $(document).off(mousemove, zoom.move);
              });
              start(e);
              $(document).on(mousemove, zoom.move);
              e.preventDefault();
            }
          });
        } else if (settings.on === 'click') {
          $source.on('click.zoom', function (e) {
            if (clicked) {
              // bubble the event up to the document to trigger the unbind.
              return;
            } else {
              clicked = true;
              start(e);
              $(document).on(mousemove, zoom.move);
              $(document).one('click.zoom', function () {
                stop();
                clicked = false;
                $(document).off(mousemove, zoom.move);
              });
              return false;
            }
          });
        } else if (settings.on === 'toggle') {
          $source.on('click.zoom', function (e) {
            if (clicked) {
              stop();
            } else {
              start(e);
            }
            clicked = !clicked;
          });
        } else if (settings.on === 'mouseover') {
          zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

          $source.on('mouseenter.zoom', start).on('mouseleave.zoom', stop).on(mousemove, zoom.move);
        } else if (settings.on === 'click-n-grab') {
          // NEW: Custom 'click-n-grab' behavior

          var isMouseDown = false;
          var startX, startY;
          var isDragging = false; // Flag to track if a drag occurred during the current mouse interaction
          var DRAG_THRESHOLD = 5; // Pixels to consider it a drag

          // Variables for persistent dragging in 'reverse' mode for 'click-n-grab'
          var lastMouseX = 0;
          var lastMouseY = 0;
          var currentImgLeft = 0; // Stores the image's left position at the start of a drag segment
          var currentImgTop = 0; // Stores the image's top position at the start of a drag segment

          $source.on('mousedown.zoom', function (e) {
            if (e.which === 1) {
              // Only left mouse button
              isMouseDown = true;
              startX = e.pageX;
              startY = e.pageY;
              isDragging = false; // Reset drag flag for this new interaction

              // Capture current image position and mouse position at the start of any potential drag
              // This is crucial for 'reverse' mode to continue from the current position
              currentImgLeft = parseFloat(img.style.left) || 0;
              currentImgTop = parseFloat(img.style.top) || 0;
              lastMouseX = e.pageX;
              lastMouseY = e.pageY;

              // Attach mousemove listener to the document for dragging
              $(document).on(mousemove, function (moveEvent) {
                if (isMouseDown) {
                  // Only process if mouse button is still down
                  // Check if movement exceeds threshold to be considered a drag
                  if (!isDragging && (Math.abs(moveEvent.pageX - startX) > DRAG_THRESHOLD || Math.abs(moveEvent.pageY - startY) > DRAG_THRESHOLD)) {
                    isDragging = true;
                    // If a drag is detected and not yet zoomed, initiate zoom here
                    if (!clicked) {
                      start(moveEvent); // Start zoom when drag is detected
                      clicked = true;
                    }
                  }
                  if (clicked) {
                    // Only move the image if it's currently zoomed
                    // zoom.move(moveEvent);
                    if (settings.moveDirection === 'reverse') {
                      var deltaX = moveEvent.pageX - lastMouseX;
                      var deltaY = moveEvent.pageY - lastMouseY;
                      var newLeft = currentImgLeft + deltaX;
                      var newTop = currentImgTop + deltaY;
                      var currentTargetWidth = $(target).outerWidth();
                      var currentTargetHeight = $(target).outerHeight();
                      ;
                      var minLeft = -(img.width - currentTargetWidth);
                      var maxLeft = 0;
                      var minTop = -(img.height - currentTargetHeight);
                      var maxTop = 0;

                      // Ensure the image doesn't move out of bounds
                      newLeft = Math.max(minLeft, Math.min(newLeft, maxLeft));
                      newTop = Math.max(minTop, Math.min(newTop, maxTop));
                      img.style.left = newLeft + 'px';
                      img.style.top = newTop + 'px';

                      // Update currentImgLeft/Top and lastMouseX/Y for the next delta calculation
                      currentImgLeft = newLeft;
                      currentImgTop = newTop;
                      lastMouseX = moveEvent.pageX;
                      lastMouseY = moveEvent.pageY;
                    } else {
                      zoom.move(moveEvent);
                    }
                  }
                }
              });
              e.preventDefault(); // Prevent default browser drag behavior
            }
          });
          $(document).on('mouseup.zoom', function (e) {
            if (isMouseDown) {
              // If mouse button was down from our mousedown event
              isMouseDown = false; // Mouse button released
              $(document).off(mousemove); // Detach mousemove listener
              // If it was a click (no drag occurred during this interaction)
              if (!isDragging) {
                if (clicked) {
                  // If currently zoomed, this click resets the zoom
                  stop(); // Reset zoom
                  clicked = false; // Mark as zoomed out
                } else {
                  // If not zoomed, this click initiates the zoom
                  start(e);
                  clicked = true; // Mark as zoomed in
                }
              }
              // If it was a drag (`isDragging` is true), the `clicked` state
              // (which would be true from `mousemove`) is maintained.
              // No change to `clicked` state on mouseup after a drag.
            }
          });
        }

        // Touch fallback
        if (settings.touch) {
          $source.on('touchstart.zoom', function (e) {
            e.preventDefault();
            if (touched) {
              touched = false;
              stop();
            } else {
              touched = true;
              start(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
            }
          }).on('touchmove.zoom', function (e) {
            e.preventDefault();
            zoom.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
          }).on('touchend.zoom', function (e) {
            e.preventDefault();
            if (touched) {
              touched = false;
              stop();
            }
          });
        }
        if ($.isFunction(settings.callback)) {
          settings.callback.call(img);
        }
      };
      img.setAttribute('role', 'presentation');
      img.alt = '';
      img.src = settings.url;
    });
  };
  $.fn.zoom.defaults = defaults;
})(window.jQuery);

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);



var PLUGIN_NAME = 'notifyMe';
var DEFAULTS = {};
var validateEmail = function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};
var setEventListeners = function setEventListeners($el, opts) {
  $el.on('click', function () {
    var $emailInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-bis-email');
    var $phoneInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-slide-bis-phone');
    var $bisContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-bis-input-container');
    var $duplicateInquiry = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-duplicate-inquiry');
    $bisContainer.removeClass('is-error');
    if (!$duplicateInquiry.hasClass('u-hide')) {
      $duplicateInquiry.addClass('u-hide');
    }
    if (!validateEmail($emailInput.val())) {
      $bisContainer.addClass('is-error');
      $emailInput.focus();
      setTimeout(function () {
        $el.progressiveButton('reset');
      }, 400);
      return;
    }
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      size: $el.data('size'),
      email: $emailInput.val(),
      phone: $phoneInput.val(),
      code: $el.data('code'),
      allowDuplicate: false
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post('/r/ajax/SubmitFindSizeInquiry.jsp', data, function (msg) {
      var result = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(msg);
      if (result.success) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-thank-you-email').html($emailInput.val());
        $bisContainer.addClass('u-hide');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-thank-you-container').removeClass('u-hide');
      } else {
        if (result.duplicate) {
          $duplicateInquiry.removeClass('u-hide');
        }
      }
      $el.progressiveButton('reset');
    });
    logEngagementWithDetails(window.location.href, 'oos similar recs', 'submit notify me', $el.data('code'));
  });
};
function notifyMe(el, options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-slide-bis-phone').mask('(000) 000-0000');
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, notifyMe);

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);


var PLUGIN_NAME = 'sizeSelection';
var CONTAINER_NAME = '.product-sizes';
var mergeOptions = function mergeOptions($el, $containerEl) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var opts = Object.assign({}, $el.data(), $containerEl.data(), options);
  return opts;
};
var showFittingRoom = function showFittingRoom(selectedSize, ispreorder) {
  var _fittingRoomErrorMsgNoPreorder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fittingRoomErrorMsgNoPreorder');
  var _fittingRoomFieldSet = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fittingRoomFieldSet');
  if (_fittingRoomFieldSet.length === 0) {
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fittingRoomErrorMsgNoSizeSelected').hide();
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#accordionTryOnItem").hasClass("accordion__item--active")) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tryon-anchor').click();
  }
  if (ispreorder) {
    _fittingRoomErrorMsgNoPreorder.show();
    _fittingRoomFieldSet.hide();
    var fitItemSizes = getFitItemSizes();
    if (fitItemSizes !== undefined && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tryon-size-options-' + fitItemSizes).length > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tryon-size-options-' + fitItemSizes).prop("checked", false);
    }
    return;
  } else {
    _fittingRoomErrorMsgNoPreorder.hide();
    _fittingRoomFieldSet.show();
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#previousSelectedSize').val().length > 0) {
    var _previousSelectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tryon-size-options-' + __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#previousSelectedSize').val());
    if (_previousSelectedSize.length > 0) {
      _previousSelectedSize.attr('disabled', false);
    }
  }
  var _currenctSelectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tryon-size-options-' + selectedSize);
  if (_currenctSelectedSize.length > 0) {
    _currenctSelectedSize.attr('disabled', true);
    _currenctSelectedSize.prop("checked", false);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#previousSelectedSize').val(selectedSize);
  }
};
var toggleForFinalSale = function toggleForFinalSale(isFinalSale, finalSaleDefective) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-free-shipping").toggle(!isFinalSale);
  if (isFinalSale || finalSaleDefective) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#freeShippingReturns').hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#freeShipping').show();
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#freeShippingReturns').show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#freeShipping').hide();
  }
};
var getFitItemSizes = function getFitItemSizes() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name=tryon-size-options]:checked').val();
};
var getHTMLJSSaveId = function getHTMLJSSaveId(value) {
  return value.toString().replace(/[\W_]+/g, "");
};
var setEventListeners = function setEventListeners($el, opts) {
  var pdpData = window.rcProps.pdp || {};
  var fitPredictor = window.rcProps.fitPredictor || {};
  $el.on('click', function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (!pdpData.isFreeReturn) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#freeShippingReturns').hide();
    }
    if (opts.isAssignedSellableDefectItemPage) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sellable-defect-item-disclaimer').show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#inventory-disclaimer').hide();
    } else {
      var defectItemPrice = opts.sellableDefectItemPrice;
      var defectItemLink = opts.sellableDefectItemLink;
      if (defectItemPrice.length > 0 && defectItemLink.length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sellableDefectItemPrice').text(defectItemPrice);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sellableDefectItemLink').prop("href", defectItemLink);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sellableDefectItem').show();
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sellableDefectItem').hide();
      }
    }
    if (el.is(':disabled')) {
      return;
    }
    var dataSize = opts.size;
    showFittingRoom(dataSize, opts.isPreorder);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product-sizes__size').removeClass('is-active');
    el.closest('.product-sizes__size').addClass('is-active');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#code').val(opts.code);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeError').fadeOut();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeValue').val(dataSize);
    var showAfterPay = true;
    var showKlarna = true;
    var firstCtaContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag-btn-preorder').closest('.js-ctas__item');
    firstCtaContainer.removeClass('u-full-width');
    if (opts.isPreorder) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#sizeNotification").hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorderinfo2").show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorderNotifyMe").show();
      if (opts.preorderDate) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#deliveryDate").html(opts.preorderDate);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#delivery").show();
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#delivery").hide();
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#regularDelivery").hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#DeliveryUrgencyMessaging').addClass("u-hide");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag-btn').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag-btn-preorder').show();
      firstCtaContainer.addClass('u-full-width');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.buy_now_element').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.liveChatEnabled').addClass("po_livechat");
      showAfterPay = false;
      showKlarna = false;
    } else if (opts.qty === 1) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#sizeNotification").show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag-btn').show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag-btn-preorder').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#delivery").hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorderNotifyMe").hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#regularDelivery").show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#DeliveryUrgencyMessaging').removeClass("u-hide");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorderinfo2").hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.buy_now_element').show();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#sizeNotification").hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag-btn').show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag-btn-preorder').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#delivery").hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorderNotifyMe").hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorderinfo2").hide();
      if (pdpData.hasEstimatedDate) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#regularDelivery").show();
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#DeliveryUrgencyMessaging').removeClass("u-hide");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.buy_now_element').show();
    }
    if (window.rcProps.payment.afterPayEnabled) {
      if (showAfterPay) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#afterPayBox").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".afterPayBoxMsg").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#afterPayBox".concat(getHTMLJSSaveId(dataSize))).show();
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#afterPayBox").hide();
      }
    } else if (window.rcProps.payment.klarnaEnabled) {
      if (showKlarna) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#klarnaPayMsgOption").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".installmentPlanBoxMsg").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#installmentPlanMsg".concat(getHTMLJSSaveId(dataSize))).show();
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#klarnaPayMsgOption").hide();
      }
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-ul li').length > 1 && !__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.size_fit_section.section_arrow').hasClass('active_arrowdown')) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeFitLink').click();
    }
    if (opts.inventoryDisclaimer) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#inventory-disclaimer').html(opts.inventoryDisclaimer);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#inventory-disclaimer').show();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#inventory-disclaimer').hide();
    }
    if (opts.onSale) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#retailPrice, .js-price-retail, #fullPriceContainer').addClass('u-hide');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fullPriceContainer').removeClass('u-flex');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#markdownPrice, .js-price-sale').html(opts.priceFormatted);
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#percentageOff').length) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#percentageOff').html(opts.discount);
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#retailPriceStrikethrough').html(opts.regularPriceFormatted);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#salePriceContainer, .js-price-sale-container').removeClass('u-hide');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#salePriceContainer').addClass('loyalty-wrap');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#salePriceContainer, .js-price-sale-container').addClass('u-hide');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#retailPrice, .js-price-retail').html(opts.priceFormatted).removeClass('u-hide');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fullPriceContainer').removeClass('u-hide');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fullPriceContainer').addClass('u-flex');
    }
    if (opts.screenReader) {
      if (opts.isPreorder) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag-btn-preorder').attr("aria-label", opts.screenReader);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag-btn').attr("aria-label", opts.screenReader);
      }
    }
    var $fitPredictorRoot = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fp-root');
    if (fitPredictor.show && $fitPredictorRoot.length) {
      var productData = ssp('get', 'product', $fitPredictorRoot.data('productId')) || {};
      productData.size = dataSize;
      productData.price = opts.price;
      if (opts.regularPrice !== opts.price) {
        productData.salePrice = opts.price;
      }
      productData.variantId = opts.code + '_' + dataSize;
      ssp('set', 'product', productData);
    }
    toggleForFinalSale(opts.finalSale, opts.finalSaleDefective);

    // Mark other colorways if this size is oos for that colorway
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-swatch').removeClass('product-swatches__swatch--oos');
    var colorsOos = opts.colorsOos;
    if (colorsOos) {
      for (var i = 0; i < colorsOos.length; i++) {
        var oosColorCode = colorsOos[i];
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-product-swatch[data-swatch-code=\"".concat(oosColorCode, "\"]")).addClass('product-swatches__swatch--oos');
      }
    }
  });
  if ($el.hasClass('size-clickable')) {
    $el.on('click', function () {
      var input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if (input.is(':checked') && typeof window.logEngagement === 'function') {
        var url = window.location.href;
        if (!opts.isBeauty) {
          var r = new URL(url);
          r.searchParams.set("size", opts.size);
          r.searchParams.set("code", opts.code);
          url = r.href;
          window.history.replaceState(null, document.title, url);
        }
        logEngagementWithDetails(url, 'PDP Size Click', 'Click', opts.size);
      }
    });
  }
};
function sizeSelection(el, options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = mergeOptions($el, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(CONTAINER_NAME), options);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, sizeSelection);

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);




var PLUGIN_NAME = 'stickyBound';
var DATA_ACTIVE = 'stickyBoundActive';

/**
 * @typedef {Object} StickyBoundOptions
 * @property {string}  fixedClass        - CSS class applied when element is fixed
 * @property {string|null} containerSelector - Selector for the bounding container; defaults to direct parent
 * @property {boolean} centerInContainer - Horizontally center the fixed element within its container
 * @property {number}  throttleWait      - ms to throttle scroll/resize handlers (0 disables throttle)
 */

/** @type {StickyBoundOptions} */
var DEFAULTS = {
  fixedClass: 'sticky-bound--is-fixed',
  containerSelector: null,
  centerInContainer: false,
  throttleWait: 100
};

/**
 * Inserts a zero-height invisible element directly before $el.
 * Stays in normal document flow at all times, giving a stable reference
 * for the element's natural document position even when $el is fixed.
 * @param {jQuery} $el
 * @returns {jQuery} $positionHolder
 */
var createPositonHolder = function createPositonHolder($el) {
  var $positionHolder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div>', {
    'aria-hidden': 'true',
    css: {
      height: 0,
      visibility: 'hidden',
      'pointer-events': 'none'
    }
  });
  $el.before($positionHolder);
  return $positionHolder;
};

/**
 * @param {jQuery} $el
 * @param {string|null} containerSelector
 * @returns {jQuery}
 */
var resolveContainer = function resolveContainer($el, containerSelector) {
  return containerSelector ? $el.closest(containerSelector) : $el.parent();
};

/**
 * Determines fixed/unfixed state and applies the fixedClass and centering styles.
 * Called on every scroll tick and after resize re-measurement.
 * @param {jQuery} $el
 * @param {jQuery} $positionHolder
 * @param {jQuery} $container
 * @param {{elFixedTop: number}} cache
 * @param {StickyBoundOptions} opts
 * @param {number} scrollTop - current window scroll position
 */
var evaluate = function evaluate($el, $positionHolder, $container, cache, opts, scrollTop) {
  var elementNaturalTop = $positionHolder.offset().top;
  var elFixedTop = cache.elFixedTop;
  var fixedClass = opts.fixedClass,
    centerInContainer = opts.centerInContainer;

  // fixed while positionHolder hasn't reached the element's fixed top position
  var shouldFix = elementNaturalTop - scrollTop > elFixedTop;
  $el.toggleClass(fixedClass, shouldFix);
  if (centerInContainer) {
    if (shouldFix) {
      var rect = $container[0].getBoundingClientRect();
      $el.css({
        left: rect.left + rect.width / 2,
        transform: 'translateX(-50%)'
      });
    } else {
      $el.css({
        left: '',
        transform: ''
      });
    }
  }
};

/**
 * Returns true if the entire element fits within the initial viewport,
 * meaning it is visible without scrolling and does not need to be fixed.
 * @param {jQuery} $positionHolder
 * @param {jQuery} $el
 * @returns {boolean}
 */
var isNaturallyInView = function isNaturallyInView($positionHolder, $el) {
  return $positionHolder.offset().top + $el.outerHeight() <= window.innerHeight;
};

/**
 * Binds scroll and resize listeners. Manages active/inactive state via
 * DATA_ACTIVE so scroll handlers are only live when the plugin needs them.
 * @param {jQuery} $el
 * @param {jQuery} $positionHolder
 * @param {jQuery} $container
 * @param {{elFixedTop: number}} cache
 * @param {StickyBoundOptions} opts
 * @param {jQuery} $window
 */
var setEventListeners = function setEventListeners($el, $positionHolder, $container, cache, opts, $window) {
  var throttleWait = opts.throttleWait,
    fixedClass = opts.fixedClass;
  var maybeThrottle = function maybeThrottle(fn) {
    return throttleWait > 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(fn, throttleWait) : fn;
  };
  var onScroll = function onScroll() {
    if (!$el.data(DATA_ACTIVE)) return;
    evaluate($el, $positionHolder, $container, cache, opts, $window.scrollTop());
  };
  var bindScroll = function bindScroll() {
    $window.on("scroll.".concat(PLUGIN_NAME), maybeThrottle(onScroll));
    $window.on("scroll.".concat(PLUGIN_NAME, "--settle"), __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(onScroll, 150));
  };

  /** Measures elFixedTop, binds scroll listeners, and runs initial evaluate. */
  var activate = function activate() {
    $el.data(DATA_ACTIVE, true);
    $el.addClass(fixedClass);
    cache.elFixedTop = $el[0].getBoundingClientRect().top;
    bindScroll();
    evaluate($el, $positionHolder, $container, cache, opts, $window.scrollTop());
  };

  /** Releases fixed state and removes scroll listeners. */
  var deactivate = function deactivate() {
    $el.data(DATA_ACTIVE, false).removeClass(fixedClass).css({
      left: '',
      transform: ''
    });
    $window.off("scroll.".concat(PLUGIN_NAME)).off("scroll.".concat(PLUGIN_NAME, "--settle"));
  };
  var onResize = function onResize() {
    var inView = isNaturallyInView($positionHolder, $el);
    var isActive = $el.data(DATA_ACTIVE);
    if (inView) {
      if (isActive) deactivate();
      return;
    }
    if (!isActive) {
      activate();
      return;
    }

    // Still active — re-measure elFixedTop for new viewport size
    $el.addClass(fixedClass);
    cache.elFixedTop = $el[0].getBoundingClientRect().top;
    evaluate($el, $positionHolder, $container, cache, opts, $window.scrollTop());
  };
  if (!isNaturallyInView($positionHolder, $el)) activate();
  $window.on("resize.".concat(PLUGIN_NAME), maybeThrottle(onResize));
};

/**
 * jQuery plugin that keeps an element `position: fixed` until its natural
 * document position (tracked by a zero-height positionHolder sibling) scrolls
 * back into the viewport, then releases it to normal flow with no visual jump.
 *
 * Skips activation if the element fits within the initial viewport. Re-activates
 * on resize if the viewport shrinks and the element falls below the fold.
 *
 * @param {HTMLElement} el
 * @param {Partial<StickyBoundOptions>} options
 */
function stickyBound(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = Object.assign({}, DEFAULTS, $el.data(), options);
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  var $container = resolveContainer($el, opts.containerSelector);
  var $positionHolder = createPositonHolder($el);
  var cache = {};
  $el.data(DATA_ACTIVE, false);
  setEventListeners($el, $positionHolder, $container, cache, opts, $window);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, stickyBound);

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_HANDLER */
/* unused harmony export CHANGE_HANDLER */
/* unused harmony export FOCUS_HANDLER */
/* unused harmony export BLUR_HANDLER */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_slick_slider__ = __webpack_require__(64);
/**
 * Toggle Display on click
 * @module styliticsToggle
 */





var PLUGIN_NAME = "styliticsToggle";
var CLICK_HANDLER = "click";
var CHANGE_HANDLER = "change";
var FOCUS_HANDLER = "focus";
var BLUR_HANDLER = "blur";
var DEFAULTS = {};
var initSlider = function initSlider(toggleCarousel) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toggleCarousel).slickSlider({
    slidesToShow: 3,
    slidesToScroll: 2,
    infinite: false
  });
};

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var toggler = function toggler($el, toggleShow, toggleHide, toggleAnimation, parentBlock, toggleCarousel) {
  if (toggleAnimation === "pop") {
    if (parentBlock) {
      $el.closest(parentBlock).find(toggleShow).show();
      if (toggleCarousel) {
        initSlider(toggleCarousel);
      }
      $el.closest(parentBlock).find(toggleHide).hide();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toggleShow).show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toggleHide).hide();
    }
  } else {
    if (parentBlock) {
      $el.closest(parentBlock).find(toggleShow).slideDown();
      if (toggleCarousel) {
        initSlider(toggleCarousel);
      }
      $el.closest(parentBlock).find(toggleHide).slideUp();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toggleShow).slideDown();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toggleHide).slideUp();
    }
  }
};
var setEventListeners = function setEventListeners($el, opts) {
  var toggleHide = opts.toggleHide,
    toggleShow = opts.toggleShow,
    toggleAnimation = opts.toggleAnimation,
    parentBlock = opts.parentBlock,
    toggleCarousel = opts.toggleCarousel;
  $el.on(CLICK_HANDLER, function () {
    toggler($el, toggleShow, toggleHide, toggleAnimation, parentBlock, toggleCarousel);
  });
  $el.on(FOCUS_HANDLER, function () {
    toggler($el, toggleShow, toggleHide, toggleAnimation, parentBlock, toggleCarousel);
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function styliticsToggle(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, styliticsToggle);

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

/* jshint -W071, -W074 */
/* global jQuery:false */

/* Disabled options are:
 * W071: This function has too many statements
 * W074: This function's cyclomatic complexity is too high
 */

/*
 *	jQuery ezPlus 1.1.21
 *	Demo's and documentation:
 *	http://igorlino.github.io/elevatezoom-plus/
 *
 *	licensed under MIT license.
 *	http://en.wikipedia.org/wiki/MIT_License
 *
 */

if (typeof Object.create !== 'function') {
    Object.create = function (obj) {
        function F() {
        }

        F.prototype = obj;
        return new F();
    };
}

(function ($, window, document, undefined) {
    var EZP = {
        init: function (options, elem) {
            var self = this;
            var $galleries;

            self.elem = elem;
            self.$elem = $(elem);

            self.options = $.extend({}, $.fn.ezPlus.options, self.responsiveConfig(options || {}));

            self.imageSrc = self.$elem.data(self.options.attrImageZoomSrc) ? self.$elem.data(self.options.attrImageZoomSrc) : self.$elem.attr('src');

            if (!self.options.enabled) {
                return;
            }

            //TINT OVERRIDE SETTINGS
            if (self.options.tint) {
                self.options.lensColour = 'transparent'; //colour of the lens background
                self.options.lensOpacity = '1'; //opacity of the lens
            }
            //INNER OVERRIDE SETTINGS
            if (self.options.zoomType === 'inner') {
                self.options.showLens = false;
            }

            // LENS OVERRIDE SETTINGS
            if (self.options.zoomType === 'lens') {
                self.options.zoomWindowWidth = 0;
            }

            //UUID WHEN MISSING IDENTIFIER
            if (self.options.zoomId === -1) {
                self.options.zoomId = generateUUID();
            }

            //Remove alt on hover

            self.$elem.parent().removeAttr('title').removeAttr('alt');

            self.zoomImage = self.imageSrc;

            self.refresh(1);

            //Create the image swap from the gallery
            $galleries = $(self.options.gallery ? ('#' + self.options.gallery) : self.options.gallerySelector);
            $galleries.on('click.zoom', self.options.galleryItem, function (e) {

                //Set a class on the currently active gallery image
                if (self.options.galleryActiveClass) {
                    $(self.options.galleryItem, $galleries).removeClass(self.options.galleryActiveClass);
                    $(this).addClass(self.options.galleryActiveClass);
                }
                //stop any link on the a tag from working
                if (this.tagName === 'A') {
                    e.preventDefault();
                }

                //call the swap image function
                if ($(this).data(self.options.attrImageZoomSrc)) {
                    self.zoomImagePre = $(this).data(self.options.attrImageZoomSrc);
                }
                else {
                    self.zoomImagePre = $(this).data('image');
                }
                self.swaptheimage($(this).data('image'), self.zoomImagePre);
                if (this.tagName === 'A') {
                    return false;
                }
            });

            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }
        },
        refresh: function (length) {
            var self = this;

            setTimeout(function () {
                self.fetch(self.imageSrc, self.$elem, self.options.minZoomLevel);

            }, length || self.options.refresh);
        },
        fetch: function (imgsrc, element, minZoom) {
            //get the image
            var self = this;
            var newImg = new Image();
            newImg.onload = function () {
                //set the large image dimensions - used to calculte ratio's
                if (newImg.width / element.width() <= minZoom) {
                    self.largeWidth = element.width() * minZoom;
                } else {
                    self.largeWidth = newImg.width;
                }
                if (newImg.height / element.height() <= minZoom) {
                    self.largeHeight = element.height() * minZoom;
                } else {
                    self.largeHeight = newImg.height;
                }
                //once image is loaded start the calls
                self.startZoom();
                self.currentImage = self.imageSrc;
                //let caller know image has been loaded
                self.options.onZoomedImageLoaded(self.$elem);
            };
            self.setImageSource(newImg, imgsrc); // this must be done AFTER setting onload

            return;
        },
        setImageSource: function (image, src) {
            //sets an image's source.
            image.src = src;
        },
        startZoom: function () {
            var self = this;
            //get dimensions of the non zoomed image
            self.nzWidth = self.$elem.width();
            self.nzHeight = self.$elem.height();

            //activated elements
            self.isWindowActive = false;
            self.isLensActive = false;
            self.isTintActive = false;
            self.overWindow = false;

            //CrossFade Wrapper
            if (self.options.imageCrossfade) {
                self.zoomWrap = self.$elem.wrap('<div style="height:' + self.nzHeight + 'px;width:' + self.nzWidth + 'px;" class="zoomWrapper" />');
                self.$elem.css('position', 'absolute');
            }

            self.zoomLock = 1;
            self.scrollingLock = false;
            self.changeBgSize = false;
            self.currentZoomLevel = self.options.zoomLevel;

            //get offset of the non zoomed image
            self.updateOffset(self);
            //calculate the width ratio of the large/small image
            self.widthRatio = (self.largeWidth / self.currentZoomLevel) / self.nzWidth;
            self.heightRatio = (self.largeHeight / self.currentZoomLevel) / self.nzHeight;

            function getWindowZoomStyle() {
                return 'display: none;' +
                    'position: absolute;' +
                    'float: left;' +
                    'height: ' + String(self.options.zoomWindowHeight) + 'px;' +
                    'width: ' + String(self.options.zoomWindowWidth) + 'px;' +
                    'text-align: center;' +
                    'border: ' + String(self.options.borderSize) + 'px solid ' + self.options.borderColour + ';' +
                    'background-size: ' + self.largeWidth / self.currentZoomLevel + 'px ' + self.largeHeight / self.currentZoomLevel + 'px;' +
                    'background-position: 0px 0px;' +
                    'background-repeat: no-repeat;' +
                    'background-color: ' + String(self.options.zoomWindowBgColour) + ';' +
                    'overflow: hidden;' +
                    'z-index: 100;';
            }

            //if window zoom
            if (self.options.zoomType === 'window') {
                self.zoomWindowStyle = getWindowZoomStyle();
            }

            function getInnerZoomStyle() {
                //has a border been put on the image? Lets cater for this
                var borderWidth = self.$elem.css('border-left-width');

                return 'display: none;' +
                    'position: absolute;' +
                    'float: left;' +
                    'height: ' + String(self.nzHeight) + 'px;' +
                    'width: ' + String(self.nzWidth) + 'px;' +
                    'margin-top: ' + String(borderWidth) + ';' +
                    'margin-left: ' + String(borderWidth) + ';' +
                    'border: ' + String(self.options.borderSize) + 'px solid ' + self.options.borderColour + ';' +
                    'background-position: 0px 0px;' +
                    'background-repeat: no-repeat;' +
                    'cursor:' + (self.options.cursor) + ';' +
                    'overflow: hidden;' +
                    'zindex: ' + self.options.zIndex + ";";
            }

            //if inner  zoom
            if (self.options.zoomType === 'inner') {
                self.zoomWindowStyle = getInnerZoomStyle();
            }

            function getWindowLensStyle() {
                // adjust images less than the window height

                if (self.nzHeight < self.options.zoomWindowHeight / self.heightRatio) {
                    self.lensHeight = self.nzHeight;
                }
                else {
                    self.lensHeight = String(self.options.zoomWindowHeight / self.heightRatio);
                }
                if (self.largeWidth < self.options.zoomWindowWidth) {
                    self.lensWidth = self.nzWidth;
                }
                else {
                    self.lensWidth = String(self.options.zoomWindowWidth / self.widthRatio);
                }

                return 'display: none;' +
                    'position: absolute;' +
                    'float: right;' +
                    'height: ' + self.lensHeight + 'px;' +
                    'width: ' + self.lensWidth + 'px;' +
                    'border: ' + (self.options.lensBorderSize) + 'px' + ' solid ' + (self.options.lensBorderColour) + ';' +
                    'background-position: 0px 0px;' +
                    'background-repeat: no-repeat;' +
                    'background-color: ' + (self.options.lensColour) + ';' +
                    'opacity: ' + (self.options.lensOpacity) + ';' +
                    'filter: alpha(opacity = ' + (self.options.lensOpacity * 100) + ');' +
                    'zoom: 1;' +
                    'cursor:' + (self.options.cursor) + ';' +
                    'z-index: 999;' +
                    'overflow: hidden;';
            }

            //lens style for window zoom
            if (self.options.zoomType === 'window') {
                self.lensStyle = getWindowLensStyle();
            }

            //tint style
            self.tintStyle =
                'display: block;' +
                'position: absolute;' +
                'height: ' + self.nzHeight + 'px;' +
                'width: ' + self.nzWidth + 'px;' +
                'background-color: ' + self.options.tintColour + ';' +
                'filter: alpha(opacity=0);' +
                'opacity: 0;';

            //lens style for lens zoom with optional round for modern browsers
            self.lensRound = '';

            if (self.options.zoomType === 'lens') {
                self.lensStyle =
                    'display: none;' +
                    'position: absolute;' +
                    'float: left;' +
                    'height:' + String(self.options.lensSize) + 'px;' +
                    'width:' + String(self.options.lensSize) + 'px;' +
                    'border: ' + String(self.options.borderSize) + 'px solid ' + self.options.borderColour + ';' +
                    'background-position: 0px 0px;' +
                    'background-repeat: no-repeat;' +
                    'background-color: ' + self.options.lensColour + ";" +
                    'cursor:' + (self.options.cursor) + ';';
            }

            //does not round in all browsers
            if (self.options.lensShape === 'round') {
                self.lensRound =
                    'border-radius: ' + String(self.options.lensSize / 2 + self.options.borderSize) + 'px;';
            }

            //create the div's                                                + ""
            //self.zoomContainer = $('<div/>').addClass('zoomContainer').css({"position":"relative", "height":self.nzHeight, "width":self.nzWidth});

            self.zoomContainer =
                $('<div class="zoomContainer" ' +
                'uuid="' + self.options.zoomId + '"' +
                'style="' +
                'position: absolute;' +
                'top: ' + self.nzOffset.top + 'px;' +
                'left: ' + self.nzOffset.left + 'px;' +
                'height: ' + self.nzHeight + 'px;' + '' +
                'width: ' + self.nzWidth + 'px;' +
                'z-index: ' + self.options.zIndex + '"></div>');
            if (self.$elem.attr('id')) {
                self.zoomContainer.attr('id', self.$elem.attr('id') + '-zoomContainer');
            }
            $(self.options.zoomContainerAppendTo).append(self.zoomContainer);

            //this will add overflow hidden and contrain the lens on lens mode
            if (self.options.containLensZoom && self.options.zoomType === 'lens') {
                self.zoomContainer.css('overflow', 'hidden');
            }
            if (self.options.zoomType !== 'inner') {
                self.zoomLens = $('<div class="zoomLens" style="' + self.lensStyle + self.lensRound + '">&nbsp;</div>')
                    .appendTo(self.zoomContainer)
                    .click(function () {
                        self.$elem.trigger('click');
                    });

                if (self.options.tint) {
                    self.tintContainer = $('<div/>').addClass('tintContainer');
                    self.zoomTint = $('<div class="zoomTint" style="' + self.tintStyle + '"></div>');

                    self.zoomLens.wrap(self.tintContainer);

                    self.zoomTintcss = self.zoomLens.after(self.zoomTint);

                    //if tint enabled - set an image to show over the tint

                    self.zoomTintImage = $('<img style="' +
                    'position: absolute;' +
                    'top: 0px;' +
                    'left: 0px;' +
                    'height: ' + self.nzHeight + 'px;" ' +
                    'width: ' + self.nzWidth + 'px; ' +
                    'max-width: none; ' +
                    'src="' + self.$elem.attr('src') + '">')
                        .appendTo(self.zoomLens)
                        .click(function () {
                            self.$elem.trigger('click');
                        });
                }
            }

            //create zoom window
            var targetZoomContainer = isNaN(self.options.zoomWindowPosition) ? 'body' : self.zoomContainer;
            self.zoomWindow = $('<div style="' +
            'z-index: 999;' +
            'top: ' + (self.windowOffsetTop) + 'px;' +
            'left: ' + (self.windowOffsetLeft) + 'px;' +
            self.zoomWindowStyle + '" class="zoomWindow">&nbsp;</div>')
                .appendTo(targetZoomContainer).click(function () {
                    self.$elem.trigger('click');
                });
            self.zoomWindowContainer = $('<div/>').addClass('zoomWindowContainer').css('width', self.options.zoomWindowWidth);
            self.zoomWindow.wrap(self.zoomWindowContainer);

            //  self.captionStyle = "text-align: left;background-color: black;'+
            // 'color: white;font-weight: bold;padding: 10px;font-family: sans-serif;font-size: 11px";
            // self.zoomCaption = $('<div class="ezplus-caption" '+
            // 'style="'+self.captionStyle+'display: block; width: 280px;">INSERT ALT TAG</div>').appendTo(self.zoomWindow.parent());

            if (self.options.zoomType === 'lens') {
                self.zoomLens.css('background-image', 'url("' + self.imageSrc + '")');
            }
            if (self.options.zoomType === 'window') {
                self.zoomWindow.css('background-image', 'url("' + self.imageSrc + '")');
            }
            if (self.options.zoomType === 'inner') {
                self.zoomWindow.css('background-image', 'url("' + self.imageSrc + '")');
            }

            /*-------------------END THE ZOOM WINDOW AND LENS----------------------------------*/
            if (self.options.touchEnabled) {
                //touch events
                self.$elem.bind('touchmove.ezpspace', function (e) {
                    e.preventDefault();
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    self.setPosition(touch);
                });
                self.zoomContainer.bind('touchmove.ezpspace', function (e) {
                    self.setElements('show');
                    e.preventDefault();
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    self.setPosition(touch);

                });
                self.zoomContainer.bind('touchend.ezpspace', function (e) {
                    self.showHideWindow('hide');
                    if (self.options.showLens) {
                        self.showHideLens('hide');
                    }
                    if (self.options.tint && self.options.zoomType !== 'inner') {
                        self.showHideTint('hide');
                    }
                });

                self.$elem.bind('touchend.ezpspace', function (e) {
                    self.showHideWindow('hide');
                    if (self.options.showLens) {
                        self.showHideLens('hide');
                    }
                    if (self.options.tint && self.options.zoomType !== 'inner') {
                        self.showHideTint('hide');
                    }
                });
                if (self.options.showLens) {
                    self.zoomLens.bind('touchmove.ezpspace', function (e) {

                        e.preventDefault();
                        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                        self.setPosition(touch);
                    });

                    self.zoomLens.bind('touchend.ezpspace', function (e) {
                        self.showHideWindow('hide');
                        if (self.options.showLens) {
                            self.showHideLens('hide');
                        }
                        if (self.options.tint && self.options.zoomType !== 'inner') {
                            self.showHideTint('hide');
                        }
                    });
                }
            }
            //Needed to work in IE
            self.$elem.bind('mousemove.ezpspace', function (e) {
                if (self.overWindow === false) {
                    self.setElements('show');
                }
                //make sure on orientation change the setposition is not fired
                if (self.lastX !== e.clientX || self.lastY !== e.clientY) {
                    self.setPosition(e);
                    self.currentLoc = e;
                }
                self.lastX = e.clientX;
                self.lastY = e.clientY;

            });

            self.zoomContainer.bind('click.ezpspace touchstart.ezpspace', self.options.onImageClick);

            self.zoomContainer.bind('mousemove.ezpspace', function (e) {
                if (self.overWindow === false) {
                    self.setElements('show');
                }
                mouseMoveZoomHandler(e);
            });

            function mouseMoveZoomHandler(e) {
                //self.overWindow = true;
                //make sure on orientation change the setposition is not fired
                if (self.lastX !== e.clientX || self.lastY !== e.clientY) {
                    self.setPosition(e);
                    self.currentLoc = e;
                }
                self.lastX = e.clientX;
                self.lastY = e.clientY;
            }

            var elementToTrack = null;
            if (self.options.zoomType !== 'inner') {
                elementToTrack = self.zoomLens;
            }
            if (self.options.tint && self.options.zoomType !== 'inner') {
                elementToTrack = self.zoomTint;
            }
            if (self.options.zoomType === 'inner') {
                elementToTrack = self.zoomWindow;
            }

            //register the mouse tracking
            if (elementToTrack) {
                elementToTrack.bind('mousemove.ezpspace', mouseMoveZoomHandler);
            }

            //  lensFadeOut: 500,  zoomTintFadeIn
            self.zoomContainer.add(self.$elem).mouseenter(function () {
                if (self.overWindow === false) {
                    self.setElements('show');
                }
            }).mouseleave(function () {
                if (!self.scrollLock) {
                    self.setElements('hide');
                    self.options.onDestroy(self.$elem);
                }
            });
            //end ove image

            if (self.options.zoomType !== 'inner') {
                self.zoomWindow.mouseenter(function () {
                    self.overWindow = true;
                    self.setElements('hide');
                }).mouseleave(function () {
                    self.overWindow = false;
                });
            }
            //end ove image

            // var delta = parseInt(e.originalEvent.wheelDelta || -e.originalEvent.detail);

            //      $(this).empty();
            //    return false;

            //fix for initial zoom setting
            //if (self.options.zoomLevel !== 1) {
            //    	self.changeZoomLevel(self.currentZoomLevel);
            //}
            //set the min zoomlevel
            if (self.options.minZoomLevel) {
                self.minZoomLevel = self.options.minZoomLevel;
            }
            else {
                self.minZoomLevel = self.options.scrollZoomIncrement * 2;
            }

            if (self.options.scrollZoom) {
                //see compatibility of mouse events at https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel
                self.zoomContainer.add(self.$elem).bind('wheel DOMMouseScroll MozMousePixelScroll', function (e) {
                    // in IE there is issue with firing of mouseleave - So check whether still scrolling
                    // and on mouseleave check if scrolllock
                    self.scrollLock = true;
                    clearTimeout($.data(this, 'timer'));
                    $.data(this, 'timer', setTimeout(function () {
                        self.scrollLock = false;
                        //do something
                    }, 250));

                    var theEvent = e.originalEvent.deltaY || e.originalEvent.detail * -1;

                    //this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                    //   e.preventDefault();

                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    e.preventDefault();

                    if (theEvent == 0) {
                        // fixes last event inversion bug
                        return false;
                    }

                    if (theEvent / 120 > 0) {
                        var nextZoomLevel = parseFloat(self.currentZoomLevel) - self.options.scrollZoomIncrement;
                        //scrolling up
                        if (nextZoomLevel >= parseFloat(self.minZoomLevel)) {
                            self.changeZoomLevel(nextZoomLevel);
                        }
                    }
                    else {
                        //scrolling down

                        //Check if it has to maintain original zoom window aspect ratio or not
                        if ((!self.fullheight && !self.fullwidth) || !self.options.mantainZoomAspectRatio) {
                            var nextZoomLevel = parseFloat(self.currentZoomLevel) + self.options.scrollZoomIncrement;

                            if (self.options.maxZoomLevel) {
                                if (nextZoomLevel <= self.options.maxZoomLevel) {
                                    self.changeZoomLevel(nextZoomLevel);
                                }
                            }
                            else {
                                //andy
                                self.changeZoomLevel(nextZoomLevel);
                            }
                        }
                    }
                    return false;
                });
            }
        },
        destroy: function () {
            var self = this;
            self.$elem.unbind('ezpspace');
            $(self.zoomContainer).remove();
            if (self.options.loadingIcon && !!self.spinner && !!self.spinner.length) {
                self.spinner.remove();
                delete self.spinner;
            }
        },
        getIdentifier: function () {
            var self = this;
            return self.options.zoomId;
        },
        setElements: function (type) {
            var self = this;
            if (!self.options.zoomEnabled) {
                return false;
            }
            if (type === 'show') {
                if (self.isWindowSet) {
                    if (self.options.zoomType === 'inner') {
                        self.showHideWindow('show');
                    }
                    if (self.options.zoomType === 'window') {
                        self.showHideWindow('show');
                    }
                    if (self.options.showLens) {
                        self.showHideLens('show');
                    }
                    if (self.options.tint && self.options.zoomType !== 'inner') {
                        self.showHideTint('show');
                    }
                }
            }

            if (type === 'hide') {
                if (self.options.zoomType === 'window') {
                    self.showHideWindow('hide');
                }
                if (!self.options.tint) {
                    self.showHideWindow('hide');
                }
                if (self.options.showLens) {
                    self.showHideLens('hide');
                }
                if (self.options.tint) {
                    self.showHideTint('hide');
                }
            }
        },
        setPosition: function (e) {

            var self = this;

            if (!self.options.zoomEnabled) {
                return false;
            }

            //recaclc offset each time in case the image moves
            //this can be caused by other on page elements
            self.nzHeight = self.$elem.height();
            self.nzWidth = self.$elem.width();
            self.updateOffset(self);

            if (self.options.tint && self.options.zoomType !== 'inner') {
                self.zoomTint.css({
                    top: 0,
                    left: 0
                });
            }
            //set responsive
            //will checking if the image needs changing before running this code work faster?
            if (self.options.responsive && !self.options.scrollZoom) {
                if (self.options.showLens) {
                    var lensHeight, lensWidth;
                    if (self.nzHeight < self.options.zoomWindowWidth / self.widthRatio) {
                        self.lensHeight = self.nzHeight;
                    }
                    else {
                        self.lensHeight = String((self.options.zoomWindowHeight / self.heightRatio));
                    }
                    if (self.largeWidth < self.options.zoomWindowWidth) {
                        self.lensWidth = self.nzWidth;
                    }
                    else {
                        self.lensWidth = (self.options.zoomWindowWidth / self.widthRatio);
                    }
                    self.widthRatio = self.largeWidth / self.nzWidth;
                    self.heightRatio = self.largeHeight / self.nzHeight;
                    if (self.options.zoomType !== 'lens') {
                        //possibly dont need to keep recalcalculating
                        //if the lens is heigher than the image, then set lens size to image size
                        if (self.nzHeight < self.options.zoomWindowWidth / self.widthRatio) {
                            self.lensHeight = self.nzHeight;

                        }
                        else {
                            self.lensHeight = String((self.options.zoomWindowHeight / self.heightRatio));
                        }

                        if (self.nzWidth < self.options.zoomWindowHeight / self.heightRatio) {
                            self.lensWidth = self.nzWidth;
                        }
                        else {
                            self.lensWidth = String((self.options.zoomWindowWidth / self.widthRatio));
                        }

                        self.zoomLens.css({
                            'width': self.lensWidth,
                            'height': self.lensHeight
                        });

                        if (self.options.tint) {
                            self.zoomTintImage.css({
                                'width': self.nzWidth,
                                'height': self.nzHeight
                            });
                        }

                    }
                    if (self.options.zoomType === 'lens') {
                        self.zoomLens.css({
                            width: String(self.options.lensSize) + 'px',
                            height: String(self.options.lensSize) + 'px'
                        });
                    }
                    //end responsive image change
                }
            }

            //container fix
            self.zoomContainer.css({
                top: self.nzOffset.top,
                left: self.nzOffset.left,
                width: self.nzWidth,  // new code
                height: self.nzHeight // new code
            });
            self.mouseLeft = parseInt(e.pageX - self.nzOffset.left);
            self.mouseTop = parseInt(e.pageY - self.nzOffset.top);
            //calculate the Location of the Lens

            //calculate the bound regions - but only if zoom window
            if (self.options.zoomType === 'window') {
                var zoomLensHeight = self.zoomLens.height() / 2;
                var zoomLensWidth = self.zoomLens.width() / 2;
                self.Etoppos = (self.mouseTop < 0 + zoomLensHeight);
                self.Eboppos = (self.mouseTop > self.nzHeight - zoomLensHeight - (self.options.lensBorderSize * 2));
                self.Eloppos = (self.mouseLeft < 0 + zoomLensWidth);
                self.Eroppos = (self.mouseLeft > (self.nzWidth - zoomLensWidth - (self.options.lensBorderSize * 2)));
            }
            //calculate the bound regions - but only for inner zoom
            if (self.options.zoomType === 'inner') {
                self.Etoppos = (self.mouseTop < ((self.nzHeight / 2) / self.heightRatio));
                self.Eboppos = (self.mouseTop > (self.nzHeight - ((self.nzHeight / 2) / self.heightRatio)));
                self.Eloppos = (self.mouseLeft < 0 + (((self.nzWidth / 2) / self.widthRatio)));
                self.Eroppos = (self.mouseLeft > (self.nzWidth - (self.nzWidth / 2) / self.widthRatio - (self.options.lensBorderSize * 2)));
            }

            // if the mouse position of the slider is one of the outerbounds, then hide  window and lens
            if (self.mouseLeft < 0 || self.mouseTop < 0 || self.mouseLeft > self.nzWidth || self.mouseTop > self.nzHeight) {
                self.setElements('hide');
                return;
            }
            //else continue with operations
            else {
                //lens options
                if (self.options.showLens) {
                    //		self.showHideLens('show');
                    //set background position of lens
                    self.lensLeftPos = String(Math.floor(self.mouseLeft - self.zoomLens.width() / 2));
                    self.lensTopPos = String(Math.floor(self.mouseTop - self.zoomLens.height() / 2));
                }
                //adjust the background position if the mouse is in one of the outer regions

                //Top region
                if (self.Etoppos) {
                    self.lensTopPos = 0;
                }
                //Left Region
                if (self.Eloppos) {
                    self.windowLeftPos = 0;
                    self.lensLeftPos = 0;
                    self.tintpos = 0;
                }
                //Set bottom and right region for window mode
                if (self.options.zoomType === 'window') {
                    if (self.Eboppos) {
                        self.lensTopPos = Math.max((self.nzHeight) - self.zoomLens.height() - (self.options.lensBorderSize * 2), 0);
                    }
                    if (self.Eroppos) {
                        self.lensLeftPos = (self.nzWidth - (self.zoomLens.width()) - (self.options.lensBorderSize * 2));
                    }
                }
                //Set bottom and right region for inner mode
                if (self.options.zoomType === 'inner') {
                    if (self.Eboppos) {
                        self.lensTopPos = Math.max(((self.nzHeight) - (self.options.lensBorderSize * 2)), 0);
                    }
                    if (self.Eroppos) {
                        self.lensLeftPos = (self.nzWidth - (self.nzWidth) - (self.options.lensBorderSize * 2));
                    }
                }
                //if lens zoom
                if (self.options.zoomType === 'lens') {

                    self.windowLeftPos = String(((e.pageX - self.nzOffset.left) * self.widthRatio - self.zoomLens.width() / 2) * (-1));
                    self.windowTopPos = String(((e.pageY - self.nzOffset.top) * self.heightRatio - self.zoomLens.height() / 2) * (-1));
                    self.zoomLens.css('background-position', self.windowLeftPos + 'px ' + self.windowTopPos + 'px');

                    if (self.changeBgSize) {
                        if (self.nzHeight > self.nzWidth) {
                            if (self.options.zoomType === 'lens') {
                                self.zoomLens.css('background-size',
                                    self.largeWidth / self.newvalueheight + 'px ' +
                                    self.largeHeight / self.newvalueheight + 'px');
                            }

                            self.zoomWindow.css('background-size',
                                self.largeWidth / self.newvalueheight + 'px ' +
                                self.largeHeight / self.newvalueheight + 'px');
                        }
                        else {
                            if (self.options.zoomType === 'lens') {
                                self.zoomLens.css('background-size',
                                    self.largeWidth / self.newvaluewidth + 'px ' +
                                    self.largeHeight / self.newvaluewidth + 'px');
                            }
                            self.zoomWindow.css('background-size',
                                self.largeWidth / self.newvaluewidth + 'px ' +
                                self.largeHeight / self.newvaluewidth + 'px');
                        }
                        self.changeBgSize = false;
                    }

                    self.setWindowPosition(e);
                }
                //if tint zoom
                if (self.options.tint && self.options.zoomType !== 'inner') {
                    self.setTintPosition(e);
                }
                //set the css background position
                if (self.options.zoomType === 'window') {
                    self.setWindowPosition(e);
                }
                if (self.options.zoomType === 'inner') {
                    self.setWindowPosition(e);
                }
                if (self.options.showLens) {
                    if (self.fullwidth && self.options.zoomType !== 'lens') {
                        self.lensLeftPos = 0;
                    }
                    self.zoomLens.css({
                        left: self.lensLeftPos + 'px',
                        top: self.lensTopPos + 'px'
                    });
                }

            } //end else
        },
        showHideZoomContainer: function (change) {
            var self = this;
            if (change === 'show') {
                if (self.zoomContainer) {
                    self.zoomContainer.show();
                }
            }
            if (change === 'hide') {
                if (self.zoomContainer) {
                    self.zoomContainer.hide();
                }
            }
        },
        showHideWindow: function (change) {
            var self = this;
            if (change === 'show') {
                if (!self.isWindowActive && self.zoomWindow) {
                    self.options.onShow(self);
                    if (self.options.zoomWindowFadeIn) {
                        self.zoomWindow.stop(true, true, false).fadeIn(self.options.zoomWindowFadeIn);
                    }
                    else {
                        self.zoomWindow.show();
                    }
                    self.isWindowActive = true;
                }
            }
            if (change === 'hide') {
                if (self.isWindowActive) {
                    if (self.options.zoomWindowFadeOut) {
                        self.zoomWindow.stop(true, true).fadeOut(self.options.zoomWindowFadeOut, function () {
                            if (self.loop) {
                                //stop moving the zoom window when zoom window is faded out
                                clearInterval(self.loop);
                                self.loop = false;
                            }
                        });
                    }
                    else {
                        self.zoomWindow.hide();
                    }
                    self.isWindowActive = false;
                }
            }
        },
        showHideLens: function (change) {
            var self = this;
            if (change === 'show') {
                if (!self.isLensActive) {
                    if (self.zoomLens) {
                        if (self.options.lensFadeIn) {
                            self.zoomLens.stop(true, true, false).fadeIn(self.options.lensFadeIn);
                        }
                        else {
                            self.zoomLens.show();
                        }
                    }
                    self.isLensActive = true;
                }
            }
            if (change === 'hide') {
                if (self.isLensActive) {
                    if (self.zoomLens) {
                        if (self.options.lensFadeOut) {
                            self.zoomLens.stop(true, true).fadeOut(self.options.lensFadeOut);
                        }
                        else {
                            self.zoomLens.hide();
                        }
                    }
                    self.isLensActive = false;
                }
            }
        },
        showHideTint: function (change) {
            var self = this;
            if (change === 'show') {
                if (!self.isTintActive && self.zoomTint) {

                    if (self.options.zoomTintFadeIn) {
                        self.zoomTint.css('opacity', self.options.tintOpacity).animate().stop(true, true).fadeIn('slow');
                    }
                    else {
                        self.zoomTint.css('opacity', self.options.tintOpacity).animate();
                        self.zoomTint.show();
                    }
                    self.isTintActive = true;
                }
            }
            if (change === 'hide') {
                if (self.isTintActive) {

                    if (self.options.zoomTintFadeOut) {
                        self.zoomTint.stop(true, true).fadeOut(self.options.zoomTintFadeOut);
                    }
                    else {
                        self.zoomTint.hide();
                    }
                    self.isTintActive = false;
                }
            }
        },

        setLensPosition: function (e) {
        },

        setWindowPosition: function (e) {
            //return obj.slice( 0, count );
            var self = this;

            if (!isNaN(self.options.zoomWindowPosition)) {

                switch (self.options.zoomWindowPosition) {
                    case 1: //done
                        self.windowOffsetTop = (self.options.zoomWindowOffsetY);//DONE - 1
                        self.windowOffsetLeft = (+self.nzWidth); //DONE 1, 2, 3, 4, 16
                        break;
                    case 2:
                        if (self.options.zoomWindowHeight > self.nzHeight) { //positive margin

                            self.windowOffsetTop = ((self.options.zoomWindowHeight / 2) - (self.nzHeight / 2)) * (-1);
                            self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                        }
                        else { //negative margin
                            $.noop();
                        }
                        break;
                    case 3: //done
                        self.windowOffsetTop = (self.nzHeight - self.zoomWindow.height() - (self.options.borderSize * 2)); //DONE 3,9
                        self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                        break;
                    case 4: //done
                        self.windowOffsetTop = (self.nzHeight); //DONE - 4,5,6,7,8
                        self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                        break;
                    case 5: //done
                        self.windowOffsetTop = (self.nzHeight); //DONE - 4,5,6,7,8
                        self.windowOffsetLeft = (self.nzWidth - self.zoomWindow.width() - (self.options.borderSize * 2)); //DONE - 5,15
                        break;
                    case 6:
                        if (self.options.zoomWindowHeight > self.nzHeight) { //positive margin
                            self.windowOffsetTop = (self.nzHeight);  //DONE - 4,5,6,7,8

                            self.windowOffsetLeft = ((self.options.zoomWindowWidth / 2) - (self.nzWidth / 2) + (self.options.borderSize * 2)) * (-1);
                        }
                        else { //negative margin
                            $.noop();
                        }

                        break;
                    case 7: //done
                        self.windowOffsetTop = (self.nzHeight);  //DONE - 4,5,6,7,8
                        self.windowOffsetLeft = 0; //DONE 7, 13
                        break;
                    case 8: //done
                        self.windowOffsetTop = (self.nzHeight); //DONE - 4,5,6,7,8
                        self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        break;
                    case 9:  //done
                        self.windowOffsetTop = (self.nzHeight - self.zoomWindow.height() - (self.options.borderSize * 2)); //DONE 3,9
                        self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        break;
                    case 10:
                        if (self.options.zoomWindowHeight > self.nzHeight) { //positive margin

                            self.windowOffsetTop = ((self.options.zoomWindowHeight / 2) - (self.nzHeight / 2)) * (-1);
                            self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        }
                        else { //negative margin
                            $.noop();
                        }
                        break;
                    case 11:
                        self.windowOffsetTop = (self.options.zoomWindowOffsetY);
                        self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        break;
                    case 12: //done
                        self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16
                        self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        break;
                    case 13: //done
                        self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16
                        self.windowOffsetLeft = (0); //DONE 7, 13
                        break;
                    case 14:
                        if (self.options.zoomWindowHeight > self.nzHeight) { //positive margin
                            self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16

                            self.windowOffsetLeft = ((self.options.zoomWindowWidth / 2) - (self.nzWidth / 2) + (self.options.borderSize * 2)) * (-1);
                        }
                        else { //negative margin
                            $.noop();
                        }
                        break;
                    case 15://done
                        self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16
                        self.windowOffsetLeft = (self.nzWidth - self.zoomWindow.width() - (self.options.borderSize * 2)); //DONE - 5,15
                        break;
                    case 16:  //done
                        self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16
                        self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                        break;
                    default: //done
                        self.windowOffsetTop = (self.options.zoomWindowOffsetY);//DONE - 1
                        self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                }
            } //end isNAN
            else {
                // For BC purposes, treat passed element as ID if element not found
                self.externalContainer = $(self.options.zoomWindowPosition);
                if (!self.externalContainer.length) {
                    self.externalContainer = $('#' + self.options.zoomWindowPosition);
                }

                self.externalContainerWidth = self.externalContainer.width();
                self.externalContainerHeight = self.externalContainer.height();
                self.externalContainerOffset = self.externalContainer.offset();

                self.windowOffsetTop = self.externalContainerOffset.top;//DONE - 1
                self.windowOffsetLeft = self.externalContainerOffset.left; //DONE 1, 2, 3, 4, 16

            }
            self.isWindowSet = true;
            self.windowOffsetTop = self.windowOffsetTop + self.options.zoomWindowOffsetY;
            self.windowOffsetLeft = self.windowOffsetLeft + self.options.zoomWindowOffsetX;

            self.zoomWindow.css({
                top: self.windowOffsetTop,
                left: self.windowOffsetLeft
            });

            if (self.options.zoomType === 'inner') {
                self.zoomWindow.css({
                    top: 0,
                    left: 0
                });

            }

            self.windowLeftPos = String(((e.pageX - self.nzOffset.left) * self.widthRatio - self.zoomWindow.width() / 2) * (-1));
            self.windowTopPos = String(((e.pageY - self.nzOffset.top) * self.heightRatio - self.zoomWindow.height() / 2) * (-1));
            if (self.Etoppos) {
                self.windowTopPos = 0;
            }
            if (self.Eloppos) {
                self.windowLeftPos = 0;
            }
            if (self.Eboppos) {
                self.windowTopPos = (self.largeHeight / self.currentZoomLevel - self.zoomWindow.height()) * (-1);
            }
            if (self.Eroppos) {
                self.windowLeftPos = ((self.largeWidth / self.currentZoomLevel - self.zoomWindow.width()) * (-1));
            }

            //stops micro movements
            if (self.fullheight) {
                self.windowTopPos = 0;
            }
            if (self.fullwidth) {
                self.windowLeftPos = 0;
            }

            //set the css background position
            if (self.options.zoomType === 'window' || self.options.zoomType === 'inner') {

                if (self.zoomLock === 1) {
                    //overrides for images not zoomable
                    if (self.widthRatio <= 1) {
                        self.windowLeftPos = 0;
                    }
                    if (self.heightRatio <= 1) {
                        self.windowTopPos = 0;
                    }
                }
                // adjust images less than the window height

                if (self.options.zoomType === 'window') {
                    if (self.largeHeight < self.options.zoomWindowHeight) {
                        self.windowTopPos = 0;
                    }
                    if (self.largeWidth < self.options.zoomWindowWidth) {
                        self.windowLeftPos = 0;
                    }
                }
                //set the zoomwindow background position
                if (self.options.easing) {

                    //     if(self.changeZoom){
                    //           clearInterval(self.loop);
                    //           self.changeZoom = false;
                    //           self.loop = false;

                    //            }
                    //set the pos to 0 if not set
                    if (!self.xp) {
                        self.xp = 0;
                    }
                    if (!self.yp) {
                        self.yp = 0;
                    }
                    var interval = 16;
                    if (Number.isInteger(parseInt(self.options.easing))) {
                        interval = parseInt(self.options.easing);
                    }
                    //if loop not already started, then run it
                    if (!self.loop) {
                        self.loop = setInterval(function () {
                            //using zeno's paradox

                            self.xp += (self.windowLeftPos - self.xp) / self.options.easingAmount;
                            self.yp += (self.windowTopPos - self.yp) / self.options.easingAmount;
                            if (self.scrollingLock) {

                                clearInterval(self.loop);
                                self.xp = self.windowLeftPos;
                                self.yp = self.windowTopPos;

                                self.xp = ((e.pageX - self.nzOffset.left) * self.widthRatio - self.zoomWindow.width() / 2) * (-1);
                                self.yp = (((e.pageY - self.nzOffset.top) * self.heightRatio - self.zoomWindow.height() / 2) * (-1));

                                if (self.changeBgSize) {
                                    if (self.nzHeight > self.nzWidth) {
                                        if (self.options.zoomType === 'lens') {
                                            self.zoomLens.css('background-size',
                                                self.largeWidth / self.newvalueheight + 'px ' +
                                                self.largeHeight / self.newvalueheight + 'px');
                                        }
                                        self.zoomWindow.css('background-size',
                                            self.largeWidth / self.newvalueheight + 'px ' +
                                            self.largeHeight / self.newvalueheight + 'px');
                                    }
                                    else {
                                        if (self.options.zoomType !== 'lens') {
                                            self.zoomLens.css('background-size',
                                                self.largeWidth / self.newvaluewidth + 'px ' +
                                                self.largeHeight / self.newvalueheight + 'px');
                                        }
                                        self.zoomWindow.css('background-size',
                                            self.largeWidth / self.newvaluewidth + 'px ' +
                                            self.largeHeight / self.newvaluewidth + 'px');
                                    }

                                    /*
                                     if(!self.bgxp){self.bgxp = self.largeWidth/self.newvalue;}
                                     if(!self.bgyp){self.bgyp = self.largeHeight/self.newvalue ;}
                                     if (!self.bgloop){
                                     self.bgloop = setInterval(function(){

                                     self.bgxp += (self.largeWidth/self.newvalue  - self.bgxp) / self.options.easingAmount;
                                     self.bgyp += (self.largeHeight/self.newvalue  - self.bgyp) / self.options.easingAmount;

                                     self.zoomWindow.css('background-size', self.bgxp + 'px ' + self.bgyp + 'px' );


                                     }, 16);

                                     }
                                     */
                                    self.changeBgSize = false;
                                }

                                self.zoomWindow.css('background-position', self.windowLeftPos + 'px ' + self.windowTopPos + 'px');
                                self.scrollingLock = false;
                                self.loop = false;

                            }
                            else if (Math.round(Math.abs(self.xp - self.windowLeftPos) + Math.abs(self.yp - self.windowTopPos)) < 1) {
                                //stops micro movements
                                clearInterval(self.loop);
                                self.zoomWindow.css('background-position', self.windowLeftPos + 'px ' + self.windowTopPos + 'px');
                                self.loop = false;
                            }
                            else {
                                if (self.changeBgSize) {
                                    if (self.nzHeight > self.nzWidth) {
                                        if (self.options.zoomType === 'lens') {
                                            self.zoomLens.css('background-size',
                                                self.largeWidth / self.newvalueheight + 'px ' +
                                                self.largeHeight / self.newvalueheight + 'px');
                                        }
                                        self.zoomWindow.css('background-size',
                                            self.largeWidth / self.newvalueheight + 'px ' +
                                            self.largeHeight / self.newvalueheight + 'px');
                                    }
                                    else {
                                        if (self.options.zoomType !== 'lens') {
                                            self.zoomLens.css('background-size',
                                                self.largeWidth / self.newvaluewidth + 'px ' +
                                                self.largeHeight / self.newvaluewidth + 'px');
                                        }
                                        self.zoomWindow.css('background-size',
                                            self.largeWidth / self.newvaluewidth + 'px ' +
                                            self.largeHeight / self.newvaluewidth + 'px');
                                    }
                                    self.changeBgSize = false;
                                }

                                self.zoomWindow.css('background-position', self.xp + 'px ' + self.yp + 'px');
                            }
                        }, interval);
                    }
                }
                else {
                    if (self.changeBgSize) {
                        if (self.nzHeight > self.nzWidth) {
                            if (self.options.zoomType === 'lens') {
                                self.zoomLens.css('background-size',
                                    self.largeWidth / self.newvalueheight + 'px ' +
                                    self.largeHeight / self.newvalueheight + 'px');
                            }

                            self.zoomWindow.css('background-size',
                                self.largeWidth / self.newvalueheight + 'px ' +
                                self.largeHeight / self.newvalueheight + 'px');
                        }
                        else {
                            if (self.options.zoomType === 'lens') {
                                self.zoomLens.css('background-size',
                                    self.largeWidth / self.newvaluewidth + 'px ' +
                                    self.largeHeight / self.newvaluewidth + 'px');
                            }
                            if ((self.largeHeight / self.newvaluewidth) < self.options.zoomWindowHeight) {

                                self.zoomWindow.css('background-size',
                                    self.largeWidth / self.newvaluewidth + 'px ' +
                                    self.largeHeight / self.newvaluewidth + 'px');
                            }
                            else {

                                self.zoomWindow.css('background-size',
                                    self.largeWidth / self.newvalueheight + 'px ' +
                                    self.largeHeight / self.newvalueheight + 'px');
                            }

                        }
                        self.changeBgSize = false;
                    }

                    self.zoomWindow.css('background-position',
                        self.windowLeftPos + 'px ' +
                        self.windowTopPos + 'px');
                }
            }
        },

        setTintPosition: function (e) {
            var self = this;
            var zoomLensWidth = self.zoomLens.width();
            var zoomLensHeight = self.zoomLens.height();
            self.updateOffset(self);
            self.tintpos = String(((e.pageX - self.nzOffset.left) - (zoomLensWidth / 2)) * (-1));
            self.tintposy = String(((e.pageY - self.nzOffset.top) - zoomLensHeight / 2) * (-1));
            if (self.Etoppos) {
                self.tintposy = 0;
            }
            if (self.Eloppos) {
                self.tintpos = 0;
            }
            if (self.Eboppos) {
                self.tintposy = (self.nzHeight - zoomLensHeight - (self.options.lensBorderSize * 2)) * (-1);
            }
            if (self.Eroppos) {
                self.tintpos = ((self.nzWidth - zoomLensWidth - (self.options.lensBorderSize * 2)) * (-1));
            }
            if (self.options.tint) {
                //stops micro movements
                if (self.fullheight) {
                    self.tintposy = 0;

                }
                if (self.fullwidth) {
                    self.tintpos = 0;

                }
                self.zoomTintImage.css({
                    'left': self.tintpos + 'px',
                    'top': self.tintposy + 'px'
                });
            }
        },

        swaptheimage: function (smallimage, largeimage) {
            var self = this;
            var newImg = new Image();

            if (self.options.loadingIcon && !self.spinner) {
                var styleAttr = 'background: url(\'' + self.options.loadingIcon + '\') no-repeat center;' +
                    'height:' + self.nzHeight + 'px;' +
                    'width:' + self.nzWidth + 'px;' +
                    'z-index: 2000;' +
                    'position: absolute; ' +
                    'background-position: center center;';
                if (self.options.zoomType === 'inner') {
                    styleAttr += 'top: 0px;';
                }
                self.spinner = $('<div class="ezp-spinner" style="' + styleAttr + '"></div>');
                self.$elem.after(self.spinner);
            } else if (self.spinner) {
                self.spinner.show();
            }

            self.options.onImageSwap(self.$elem);

            newImg.onload = function () {
                self.largeWidth = newImg.width;
                self.largeHeight = newImg.height;
                self.zoomImage = largeimage;
                self.zoomWindow.css('background-size', self.largeWidth + 'px ' + self.largeHeight + 'px');

                self.swapAction(smallimage, largeimage);
                return;
            };
            self.setImageSource(newImg, largeimage);  // this must be done AFTER setting onload
        },

        swapAction: function (smallimage, largeimage) {
            var self = this;
            var elemWidth = self.$elem.width();
            var elemHeight = self.$elem.height();
            var newImg2 = new Image();
            newImg2.onload = function () {
                //re-calculate values
                self.nzHeight = newImg2.height;
                self.nzWidth = newImg2.width;
                self.options.onImageSwapComplete(self.$elem);

                self.doneCallback();
                return;
            };
            self.setImageSource(newImg2, smallimage);

            //reset the zoomlevel to that initially set in options
            self.currentZoomLevel = self.options.zoomLevel;
            self.options.maxZoomLevel = false;

            //swaps the main image
            //self.$elem.attr('src',smallimage);
            //swaps the zoom image
            if (self.options.zoomType === 'lens') {
                self.zoomLens.css('background-image', 'url("' + largeimage + '")');
            }
            if (self.options.zoomType === 'window') {
                self.zoomWindow.css('background-image', 'url("' + largeimage + '")');
            }
            if (self.options.zoomType === 'inner') {
                self.zoomWindow.css('background-image', 'url("' + largeimage + '")');
            }

            self.currentImage = largeimage;

            if (self.options.imageCrossfade) {
                var oldImg = self.$elem;
                var newImg = oldImg.clone();
                self.$elem.attr('src', smallimage);
                self.$elem.after(newImg);
                newImg.stop(true).fadeOut(self.options.imageCrossfade, function () {
                    $(this).remove();
                });

                // if(self.options.zoomType === 'inner'){
                //remove any attributes on the cloned image so we can resize later
                self.$elem.width('auto').removeAttr('width');
                self.$elem.height('auto').removeAttr('height');
                //   }

                oldImg.fadeIn(self.options.imageCrossfade);

                if (self.options.tint && self.options.zoomType !== 'inner') {

                    var oldImgTint = self.zoomTintImage;
                    var newImgTint = oldImgTint.clone();
                    self.zoomTintImage.attr('src', largeimage);
                    self.zoomTintImage.after(newImgTint);
                    newImgTint.stop(true).fadeOut(self.options.imageCrossfade, function () {
                        $(this).remove();
                    });

                    oldImgTint.fadeIn(self.options.imageCrossfade);

                    //self.zoomTintImage.attr('width',elem.data('image'));

                    //resize the tint window
                    self.zoomTint.css({
                        height: elemHeight,
                        width: elemWidth
                    });
                }

                self.zoomContainer.css({
                    'height': elemHeight,
                    'width': elemWidth
                });

                if (self.options.zoomType === 'inner') {
                    if (!self.options.constrainType) {
                        self.zoomWrap.parent().css({
                            'height': elemHeight,
                            'width': elemWidth
                        });

                        self.zoomWindow.css({
                            'height': elemHeight,
                            'width': elemWidth
                        });
                    }
                }

                if (self.options.imageCrossfade) {
                    self.zoomWrap.css({
                        'height': elemHeight,
                        'width': elemWidth
                    });
                }
            }
            else {
                self.$elem.attr('src', smallimage);
                if (self.options.tint) {
                    self.zoomTintImage.attr('src', largeimage);
                    //self.zoomTintImage.attr('width',elem.data('image'));
                    self.zoomTintImage.attr('height', elemHeight);
                    //self.zoomTintImage.attr('src') = elem.data('image');
                    self.zoomTintImage.css('height', elemHeight);
                    self.zoomTint.css('height', elemHeight);

                }
                self.zoomContainer.css({
                    'height': elemHeight,
                    'width': elemWidth
                });

                if (self.options.imageCrossfade) {
                    self.zoomWrap.css({
                        'height': elemHeight,
                        'width': elemWidth
                    });
                }
            }
            if (self.options.constrainType) {

                //This will contrain the image proportions
                if (self.options.constrainType === 'height') {

                    var autoWDimension = {
                        'height': self.options.constrainSize,
                        'width': 'auto'
                    };
                    self.zoomContainer.css(autoWDimension);

                    if (self.options.imageCrossfade) {
                        self.zoomWrap.css(autoWDimension);
                        self.constwidth = self.zoomWrap.width();
                    }
                    else {
                        self.$elem.css(autoWDimension);
                        self.constwidth = elemWidth;
                    }

                    var constWDim = {
                        'height': self.options.constrainSize,
                        'width': self.constwidth
                    };
                    if (self.options.zoomType === 'inner') {

                        self.zoomWrap.parent().css(constWDim);
                        self.zoomWindow.css(constWDim);
                    }
                    if (self.options.tint) {
                        self.tintContainer.css(constWDim);
                        self.zoomTint.css(constWDim);
                        self.zoomTintImage.css(constWDim);
                    }

                }
                if (self.options.constrainType === 'width') {
                    var autoHDimension = {
                        'height': 'auto',
                        'width': self.options.constrainSize
                    };
                    self.zoomContainer.css(autoHDimension);

                    if (self.options.imageCrossfade) {
                        self.zoomWrap.css(autoHDimension);
                        self.constheight = self.zoomWrap.height();
                    }
                    else {
                        self.$elem.css(autoHDimension);
                        self.constheight = elemHeight;
                    }

                    var constHDim = {
                        'height': self.constheight,
                        'width': self.options.constrainSize
                    };
                    if (self.options.zoomType === 'inner') {
                        self.zoomWrap.parent().css(constHDim);
                        self.zoomWindow.css(constHDim);
                    }
                    if (self.options.tint) {
                        self.tintContainer.css(constHDim);
                        self.zoomTint.css(constHDim);
                        self.zoomTintImage.css(constHDim);
                    }
                }
            }
        },

        doneCallback: function () {
            var self = this;
            if (self.options.loadingIcon && !!self.spinner && !!self.spinner.length) {
                self.spinner.hide();
            }

            self.updateOffset(self);
            self.nzWidth = self.$elem.width();
            self.nzHeight = self.$elem.height();

            // reset the zoomlevel back to default
            self.currentZoomLevel = self.options.zoomLevel;

            //ratio of the large to small image
            self.widthRatio = self.largeWidth / self.nzWidth;
            self.heightRatio = self.largeHeight / self.nzHeight;

            //NEED TO ADD THE LENS SIZE FOR ROUND
            // adjust images less than the window height
            if (self.options.zoomType === 'window') {

                if (self.nzHeight < self.options.zoomWindowHeight / self.heightRatio) {
                    self.lensHeight = self.nzHeight;

                }
                else {
                    self.lensHeight = String((self.options.zoomWindowHeight / self.heightRatio));
                }

                if (self.nzWidth < self.options.zoomWindowWidth) {
                    self.lensWidth = self.nzWidth;
                }
                else {
                    self.lensWidth = (self.options.zoomWindowWidth / self.widthRatio);
                }

                if (self.zoomLens) {
                    self.zoomLens.css({
                        'width': self.lensWidth,
                        'height': self.lensHeight
                    });
                }
            }
        },

        getCurrentImage: function () {
            var self = this;
            return self.zoomImage;
        },

        getGalleryList: function () {
            var self = this;
            //loop through the gallery options and set them in list for fancybox
            self.gallerylist = [];
            if (self.options.gallery) {
                $('#' + self.options.gallery + ' a').each(function () {

                    var imgSrc = '';
                    if ($(this).data(self.options.attrImageZoomSrc)) {
                        imgSrc = $(this).data(self.options.attrImageZoomSrc);
                    }
                    else if ($(this).data('image')) {
                        imgSrc = $(this).data('image');
                    }
                    //put the current image at the start
                    if (imgSrc === self.zoomImage) {
                        self.gallerylist.unshift({
                            href: '' + imgSrc + '',
                            title: $(this).find('img').attr('title')
                        });
                    }
                    else {
                        self.gallerylist.push({
                            href: '' + imgSrc + '',
                            title: $(this).find('img').attr('title')
                        });
                    }
                });
            }
            //if no gallery - return current image
            else {
                self.gallerylist.push({
                    href: '' + self.zoomImage + '',
                    title: $(this).find('img').attr('title')
                });
            }
            return self.gallerylist;
        },

        changeZoomLevel: function (value) {
            var self = this;

            //flag a zoom, so can adjust the easing during setPosition
            self.scrollingLock = true;

            //round to two decimal places
            self.newvalue = parseFloat(value).toFixed(2);
            var newvalue = self.newvalue;

            //maxwidth & Maxheight of the image
            var maxheightnewvalue = self.largeHeight / ((self.options.zoomWindowHeight / self.nzHeight) * self.nzHeight);
            var maxwidthtnewvalue = self.largeWidth / ((self.options.zoomWindowWidth / self.nzWidth) * self.nzWidth);

            //calculate new heightratio
            if (self.options.zoomType !== 'inner') {
                if (maxheightnewvalue <= newvalue) {
                    self.heightRatio = (self.largeHeight / maxheightnewvalue) / self.nzHeight;
                    self.newvalueheight = maxheightnewvalue;
                    self.fullheight = true;
                }
                else {
                    self.heightRatio = (self.largeHeight / newvalue) / self.nzHeight;
                    self.newvalueheight = newvalue;
                    self.fullheight = false;
                }

                // calculate new width ratio

                if (maxwidthtnewvalue <= newvalue) {
                    self.widthRatio = (self.largeWidth / maxwidthtnewvalue) / self.nzWidth;
                    self.newvaluewidth = maxwidthtnewvalue;
                    self.fullwidth = true;
                }
                else {
                    self.widthRatio = (self.largeWidth / newvalue) / self.nzWidth;
                    self.newvaluewidth = newvalue;
                    self.fullwidth = false;
                }
                if (self.options.zoomType === 'lens') {
                    if (maxheightnewvalue <= newvalue) {
                        self.fullwidth = true;
                        self.newvaluewidth = maxheightnewvalue;
                    } else {
                        self.widthRatio = (self.largeWidth / newvalue) / self.nzWidth;
                        self.newvaluewidth = newvalue;

                        self.fullwidth = false;
                    }
                }
            }

            if (self.options.zoomType === 'inner') {
                maxheightnewvalue = parseFloat(self.largeHeight / self.nzHeight).toFixed(2);
                maxwidthtnewvalue = parseFloat(self.largeWidth / self.nzWidth).toFixed(2);
                if (newvalue > maxheightnewvalue) {
                    newvalue = maxheightnewvalue;
                }
                if (newvalue > maxwidthtnewvalue) {
                    newvalue = maxwidthtnewvalue;
                }

                if (maxheightnewvalue <= newvalue) {
                    self.heightRatio = (self.largeHeight / newvalue) / self.nzHeight;
                    if (newvalue > maxheightnewvalue) {
                        self.newvalueheight = maxheightnewvalue;
                    } else {
                        self.newvalueheight = newvalue;
                    }
                    self.fullheight = true;
                }
                else {
                    self.heightRatio = (self.largeHeight / newvalue) / self.nzHeight;

                    if (newvalue > maxheightnewvalue) {

                        self.newvalueheight = maxheightnewvalue;
                    } else {
                        self.newvalueheight = newvalue;
                    }
                    self.fullheight = false;
                }

                if (maxwidthtnewvalue <= newvalue) {

                    self.widthRatio = (self.largeWidth / newvalue) / self.nzWidth;
                    if (newvalue > maxwidthtnewvalue) {

                        self.newvaluewidth = maxwidthtnewvalue;
                    } else {
                        self.newvaluewidth = newvalue;
                    }

                    self.fullwidth = true;
                }
                else {
                    self.widthRatio = (self.largeWidth / newvalue) / self.nzWidth;
                    self.newvaluewidth = newvalue;
                    self.fullwidth = false;
                }
            } //end inner
            var scrcontinue = false;

            if (self.options.zoomType === 'inner') {
                if (self.nzWidth >= self.nzHeight) {
                    if (self.newvaluewidth <= maxwidthtnewvalue) {
                        scrcontinue = true;
                    }
                    else {
                        scrcontinue = false;
                        self.fullheight = true;
                        self.fullwidth = true;
                    }
                }
                if (self.nzHeight > self.nzWidth) {
                    if (self.newvaluewidth <= maxwidthtnewvalue) {
                        scrcontinue = true;
                    }
                    else {
                        scrcontinue = false;
                        self.fullheight = true;
                        self.fullwidth = true;
                    }
                }
            }

            if (self.options.zoomType !== 'inner') {
                scrcontinue = true;
            }

            if (scrcontinue) {
                self.zoomLock = 0;
                self.changeZoom = true;

                //if lens height is less than image height
                if (((self.options.zoomWindowHeight) / self.heightRatio) <= self.nzHeight) {
                    self.currentZoomLevel = self.newvalueheight;
                    if (self.options.zoomType !== 'lens' && self.options.zoomType !== 'inner') {
                        self.changeBgSize = true;
                        self.zoomLens.css('height', String(self.options.zoomWindowHeight / self.heightRatio) + 'px');
                    }
                    if (self.options.zoomType === 'lens' || self.options.zoomType === 'inner') {
                        self.changeBgSize = true;
                    }
                }

                if ((self.options.zoomWindowWidth / self.widthRatio) <= self.nzWidth) {
                    if (self.options.zoomType !== 'inner') {
                        if (self.newvaluewidth > self.newvalueheight) {
                            self.currentZoomLevel = self.newvaluewidth;
                        }
                    }

                    if (self.options.zoomType !== 'lens' && self.options.zoomType !== 'inner') {
                        self.changeBgSize = true;

                        self.zoomLens.css('width', String(self.options.zoomWindowWidth / self.widthRatio) + 'px');
                    }
                    if (self.options.zoomType === 'lens' || self.options.zoomType === 'inner') {
                        self.changeBgSize = true;
                    }

                }
                if (self.options.zoomType === 'inner') {
                    self.changeBgSize = true;

                    if (self.nzWidth > self.nzHeight) {
                        self.currentZoomLevel = self.newvaluewidth;
                    }
                    else if (self.nzHeight >= self.nzWidth) {
                        self.currentZoomLevel = self.newvaluewidth;
                    }
                }
            }      //under

            //sets the boundry change, called in setWindowPos
            self.setPosition(self.currentLoc);
            //
        },

        closeAll: function () {
            var self = this;
            if (self.zoomWindow) {
                self.zoomWindow.hide();
            }
            if (self.zoomLens) {
                self.zoomLens.hide();
            }
            if (self.zoomTint) {
                self.zoomTint.hide();
            }
        },
        updateOffset: function (self) {
            if (self.options.zoomContainerAppendTo != 'body') {
                self.nzOffset = self.$elem.offset();
                appendedPosition = $(self.options.zoomContainerAppendTo).offset();
                self.nzOffset.top = self.$elem.offset().top - appendedPosition.top;
                self.nzOffset.left = self.$elem.offset().left - appendedPosition.left;

            } else {
                self.nzOffset = self.$elem.offset();
            }
        },

        changeState: function (value) {
            var self = this;
            if (value === 'enable') {
                self.options.zoomEnabled = true;
            }
            if (value === 'disable') {
                self.options.zoomEnabled = false;
            }
        },

        responsiveConfig: function (options) {
            if (options.respond && options.respond.length > 0) {
                return $.extend({}, options, this.configByScreenWidth(options));
            }
            return options;
        },

        configByScreenWidth: function (options) {
            var screenWidth = $(window).width();

            var config = $.grep(options.respond, function (item) {
                var range = item.range.split('-');
                return (screenWidth >= range[0]) && (screenWidth <= range[1]);
            });

            if (config.length > 0) {
                return config[0];
            } else {
                return options;
            }
        }
    };

    $.fn.ezPlus = function (options) {
        return this.each(function () {
            var elevate = Object.create(EZP);

            elevate.init(options, this);

            $.data(this, 'ezPlus', elevate);

        });
    };

    $.fn.ezPlus.options = {
        attrImageZoomSrc: 'zoom-image', // attribute to plugin use for zoom
        borderColour: '#888',
        borderSize: 4,
        constrainSize: false,  //in pixels the dimensions you want to constrain on
        constrainType: false,  //width or height
        containLensZoom: false,
        cursor: 'inherit', // user should set to what they want the cursor as, if they have set a click function
        debug: false,
        easing: false,
        easingAmount: 12,
        enabled: true,

        gallery: false,
        galleryActiveClass: 'zoomGalleryActive',
        gallerySelector: false,
        galleryItem: 'a',

        imageCrossfade: false,

        lensBorderColour: '#000',
        lensBorderSize: 1,
        lensColour: 'white', //colour of the lens background
        lensFadeIn: false,
        lensFadeOut: false,
        lensOpacity: 0.4, //opacity of the lens
        lensShape: 'square', //can be 'round'
        lensSize: 200,
        lenszoom: false,

        loadingIcon: false, //http://www.example.com/spinner.gif

        // This change will allow to decide if you want to decrease
        // zoom of one of the dimensions once the other reached it's top value,
        // or keep the aspect ratio, default behaviour still being as always,
        // allow to continue zooming out, so it keeps retrocompatibility.
        mantainZoomAspectRatio: false,
        maxZoomLevel: false,
        minZoomLevel: 1.01,

        onComplete: $.noop,
        onDestroy: $.noop,
        onImageClick: $.noop,
        onImageSwap: $.noop,
        onImageSwapComplete: $.noop,
        onShow: $.noop,
        onZoomedImageLoaded: $.noop,

        preloading: 1, //by default, load all the images, if 0, then only load images after activated (PLACEHOLDER FOR NEXT VERSION)
        respond: [],
        responsive: true,
        scrollZoom: false, //allow zoom on mousewheel, true to activate
        scrollZoomIncrement: 0.1,  //steps of the scrollzoom
        showLens: true,
        tint: false, //enable the tinting
        tintColour: '#333', //default tint color, can be anything, red, #ccc, rgb(0,0,0)
        tintOpacity: 0.4, //opacity of the tint
        touchEnabled: true,

        zoomActivation: 'hover', // Can also be click (PLACEHOLDER FOR NEXT VERSION)
        zoomContainerAppendTo: 'body', //zoom container parent selector
        zoomId: -1, // identifier for the zoom container
        zoomLevel: 1, //default zoom level of image
        zoomTintFadeIn: false,
        zoomTintFadeOut: false,
        zoomType: 'window', //window is default,  also 'lens' available -
        zoomWindowAlwaysShow: false,
        zoomWindowBgColour: '#fff',
        zoomWindowFadeIn: false,
        zoomWindowFadeOut: false,
        zoomWindowHeight: 400,
        zoomWindowOffsetX: 0,
        zoomWindowOffsetY: 0,
        zoomWindowPosition: 1, //Possible values: 1-16, but we can also position with a selector string.
        zoomWindowWidth: 400,
        zoomEnabled: true, //false disables zoomwindow from showing
        zIndex: 999
    };

})(jQuery, window, document);


/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_includes_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ez_plus__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ez_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ez_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stylitics_toggle__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_slides__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styleguide_modules_abtest_lazy_video__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__size_selection__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__add_to_bag__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__add_buy_now__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notify_me__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chat_window_qa__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sticky_bound__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__jquery_zoom__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__jquery_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__jquery_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_breaky__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_breaky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_breaky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__customer_reviews__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_revieve_try_on__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_revieve_makeup_advisor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_social_proof__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__add_to_bag_function__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_modules_influencer_share_link__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_add_to_bag__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__ = __webpack_require__(27);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





















var rcProps = window.rcProps || {};
var _ref = rcProps.pdp || {},
  _ref$fullViewPath = _ref.fullViewPath,
  fullViewPath = _ref$fullViewPath === void 0 ? '' : _ref$fullViewPath,
  _ref$currentModelCoun = _ref.currentModelCountParam,
  currentModelCountParam = _ref$currentModelCoun === void 0 ? -1 : _ref$currentModelCoun;
var arabDir = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html').attr('dir');
var rtlBool = arabDir ? true : false;
window.showMeasurementGuide = function () {
  var modalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (rcProps.hasOwnProperty('pdpSizeGuideUrl') && rcProps.pdpSizeGuideUrl.length) {
    if (rcProps.hasOwnProperty('fitPredictor') && rcProps.fitPredictor.showDynamicSizeGuide) {
      ssp('start', 'sizeguide');
      ssp('track', 'triggerSizeGuide', {
        productId: rcProps.fitPredictor.code,
        origin: 'sizeguide-cta'
      });
    }
    var modalDefaultOptions = {
      url: rcProps.pdpSizeGuideUrl,
      triggerOpen: true,
      returnFocus: '#js-sizeguide-focus'
    };
    var modalSettings = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend({}, modalDefaultOptions, modalOptions);
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal(modalSettings);
  } else {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
      url: '/r/dialog/ProductMessages.jsp?error=yes'
    });
  }
};
window.showMeasurementGuideTabs = function () {
  if (rcProps.hasOwnProperty('pdpSizeGuideUrl') && rcProps.pdpSizeGuideUrl.length) {
    if (rcProps.hasOwnProperty('fitPredictor') && rcProps.fitPredictor.showDynamicSizeGuide) {
      ssp('start', 'sizeguide');
      ssp('track', 'triggerSizeGuide', {
        productId: rcProps.fitPredictor.code,
        origin: 'sizeguide-cta'
      });
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
      url: rcProps.pdpSizeGuideUrl,
      triggerOpen: true,
      returnFocus: '#js-size-guide-focus-tabs',
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-accordion').accordion();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-tabs').tabs();
        var $content = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal__content');
        var host = $content.find('ssp-sizeguide')[0];
        if (host && host.shadowRoot) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal__content').attr('aria-labelledby', 'dsg-header-0');
        }
      }
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
      url: '/r/dialog/ProductMessages.jsp?error=yes'
    });
  }
};

// Requires for Zelig Add to Cart integration
window.addToBagWithData = function (data, callback) {
  if (!data.count && __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-counter-value").length) {
    data.count = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-counter-value").text();
  }
  if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#replenish-save').is(':checked')) {
    data.subscriptionInterval = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#subscription-interval option:selected').val();
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__modules_add_to_bag__["a" /* addToBagWithData */])(data, callback);
};
function handleZeligWidgetLoaded() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-sticky-bound .zelig-widget').stickyBound({
    fixedClass: 'sticky-bound--is-fixed',
    centerInContainer: true,
    containerSelector: null,
    throttleWait: 50
  });
}
__WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
  // Can't Find Your Size
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-cant-find-size').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
      url: './sizeModal.html',
      triggerOpen: true
    });
  });

  // BIS One Size
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-bis-one-size').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
      url: './bisOneSizeModal.html',
      type: 'small',
      triggerOpen: true
    });
  });
  function runFitPredictor() {
    var onPrediction = function onPrediction(data) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#size-ul input').each(function () {
        if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('size') === data.size) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).click();
        }
      });
    };
    if (rcProps.hasOwnProperty('fitPredictor') && rcProps.fitPredictor.show) {
      ssp('subscribe', 'prediction', onPrediction);
      ssp('start', 'fitpredictor');
      ssp('start', 'stylefinder');
    }
  }

  /**
   * Custom Slick Options for PDP Full Image View
   */
  var fullProductImageView = function fullProductImageView() {
    var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    /* Initialize Jquery Zoom  */
    var initZoom = function initZoom($carousel) {
      var $zoomActive = $carousel.find('.slick-active');

      // Clear any existing zoom instances first
      $carousel.find('.js-pdp-image-zoom.zoom-active').each(function () {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).trigger('zoom.destroy');
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).removeClass('zoom-active');
      });

      // Initialize zoom on active slides
      $zoomActive.each(function (i, el) {
        // Set cursor to crosshair
        el.style.cursor = "crosshair";
        var $zoomContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).find('.js-pdp-image-zoom');
        var zoomImgUrl = $zoomContainer.data('zoom-img');
        if (zoomImgUrl && !$zoomContainer.hasClass('zoom-active')) {
          $zoomContainer.zoom({
            on: 'click-n-grab',
            // NEW: Mouse Event for settings option
            magnify: 2,
            // ONLY works when on is set to click-n-grab
            moveDirection: 'reverse',
            // Set to 'reverse' for inverted drag
            onZoomIn: function onZoomIn() {
              el.style.cursor = "grab";
            },
            onZoomOut: function onZoomOut() {
              el.style.cursor = "crosshair";
            }
          });
          $zoomContainer.addClass('zoom-active');
        }
      });
    };
    var $carousel = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-full-view');
    var thumbCount = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-full-view-thumb .js-primary-slideshow__pager-thumb').length;
    var $slickThumbs = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-full-view-thumb');
    if (!$carousel.hasClass('slick-initialized')) {
      $carousel.on('init', function (event, slick) {
        var $slickList = $carousel.find('.slick-list');
        var $slickTrack = $carousel.find('.slick-track');
        $slickList.addClass('u-height--full u-scroll-y');
        $slickTrack.addClass('u-height--full');
        initZoom($carousel);
        $carousel.find('.js-full-view-video').each(function () {
          if (this.dataset.skinned) return;
          this.dataset.skinned = 'true';
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).customVideoPlayer({
            videoMuted: false,
            hideMute: true,
            // renders the mute/volume button (flag is inverted)
            $originalTrigger: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-floating-video-button').first()
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_styleguide_modules_abtest_lazy_video__["a" /* default */])(this); // [UX-21388]
        });
      }).on('afterChange', function (event, slick) {
        initZoom($carousel);
      });
      var splitImageBreakpoint = 1190;
      var slidesToShowNum = 2;
      if (thumbCount >= 2) {
        $carousel.on('breakpoint', function (event, slick, breakpoint) {
          if (breakpoint === splitImageBreakpoint && slick.options.slidesToShow < thumbCount) {
            $slickThumbs.show();
            $slickThumbs.slick('setPosition');
          } else if (breakpoint === null && slick.options.slidesToShow >= thumbCount) {
            $slickThumbs.hide();
          }
        });
      } else {
        slidesToShowNum = 1;
        $slickThumbs.show();
      }
      $carousel.slick({
        lazyLoad: 'progressive',
        nextArrow: "#js-product-full-view-next",
        prevArrow: "#js-product-full-view-prev",
        asNavFor: '.js-full-view-thumb',
        draggable: false,
        // to fix weird parallax with jQuery Zoom JS
        rtl: rtlBool,
        slidesToShow: slidesToShowNum,
        slidesToScroll: 1,
        initialSlide: startIndex,
        responsive: [{
          breakpoint: splitImageBreakpoint,
          settings: {
            slidesToShow: 1
          }
        }]
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#js-product-full-view-prev").on('click', function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'pdp zoom modal', 'left swipe', 'PDP clicking on left arrow');
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#js-product-full-view-next").on('click', function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'pdp zoom modal', 'right swipe', 'PDP clicking on right arrow');
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-full-view-video').on('click', function () {
        var module = "PDP ".concat(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('videoLocation'));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, module, 'Video Click', __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('videoId'));
      });
      $slickThumbs.slick({
        asNavFor: '.js-product-full-view',
        vertical: true,
        focusOnSelect: true,
        arrows: false,
        centerMode: false,
        slidesToShow: thumbCount,
        verticalSwiping: true,
        initialSlide: startIndex
      });
      $slickThumbs.on('click', '.slick-slide', function () {
        var clickedThumbIndex = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('slick-index');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'pdp zoom modal', 'click thumbnail', 'PDP clicking on thumbnail image on the left');
        $carousel.slick('slickGoTo', clickedThumbIndex);
      });
    }
  };
  function changePDPColorText(colorText) {
    // unescape for chinese
    colorText = unescape((colorText || '').replaceAll(/\\u/ig, '%u'));
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.selectedColor').html(colorText);
  }
  ;
  function revertSelectedPDPColorText() {
    var checkedSwatch = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.ui-list input:checked')[0];
    var checkedSwatchColor = checkedSwatch.getAttribute('value');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.selectedColor').html(checkedSwatchColor);
  }

  // Swap swatch color image with Main Image
  function swapMainImage(elem) {
    var $imageSrcToReplaceWith = elem.attr('data-image');
    var $imageSrcSetToReplaceWith = elem.attr('data-srcset');
    var $primarySlideshowImage = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#js-primary-slideshow__image');
    $primarySlideshowImage.attr('src', $imageSrcToReplaceWith);
    $primarySlideshowImage.attr('srcset', $imageSrcSetToReplaceWith);
  }
  ;
  function initSizeJs() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-info .cantfindsize').off('click').on('click', function () {
      var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
      var showPopup = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data("showPopup");
      if (showPopup === 'special-order') {
        showSOPopup(this);
      } else if (showPopup === 'notify-me') {
        showNotifyMePopup(this);
      } else {
        showFullPopup(this);
      }
      if ($this.data('disabledSize') && typeof __WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */] === 'function') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP Sizes', 'Disabled size clicked', $this.data('sizeSelected'));
      }
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-size-option').sizeSelection();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#js-sizeguide-focus').on('click', function () {
      var type = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('type') || '';
      showMeasurementGuide({
        type: type
      });
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-similar-items-modal').on('click', function (e) {
      var $targetEl = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
        url: $targetEl.data('url'),
        type: 'half',
        overlayClose: true,
        triggerOpen: true,
        returnFocus: $targetEl,
        onComplete: function onComplete() {
          var $favoriteButtons = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal').find('.js-favorite-button');
          if (window.bindHeartEvent) {
            window.bindHeartEvent($favoriteButtons);
            $favoriteButtons.on('click', function () {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'oos similar recs', 'heart', __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('code'));
            });
          }
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-lazy-image').lazy();
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-progressive-button').progressiveButton();
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#js-bis-notify-me').notifyMe();
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-add-to-bag').on('click', function () {
            var $el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__add_to_bag_function__["a" /* pdpAddToBag */])(null, {
              code: $el.data('code'),
              size: $el.data('size'),
              src: 'oossimilar_atc'
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'oos similar recs', 'atc', $el.data('code'));
          });
        }
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'oos similar recs', 'open recs', "".concat($targetEl.data('code'), "+").concat($targetEl.data('size')));
    });
  }

  // Decides if PDP Carousel will be 1 or 2 slides
  var galleryTabletQuery = window.matchMedia('(max-width: 899px)');
  var getGallerySlidesToShow = function getGallerySlidesToShow() {
    return galleryTabletQuery.matches ? 1 : 2;
  };
  galleryTabletQuery.addEventListener('change', function () {
    var $gallery = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slides--two-column-slick.slick-initialized');
    if ($gallery.length) {
      $gallery.slick('slickSetOption', 'slidesToShow', getGallerySlidesToShow(), true);
    }
  });
  function initPDPJs() {
    var getImageHeight = function getImageHeight() {
      var $imageParentEl = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-pdp-image-zoom');
      var $jsSlideShowVideo = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slideshow__vid'); // Group A (not left/right arrow)
      var setMaxHeight = 650;
      var dynamicHeight = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).height() - __WEBPACK_IMPORTED_MODULE_1_jquery___default()('header').height() - 70; // 70 to give a buffer
      var maxHeight = dynamicHeight > setMaxHeight ? setMaxHeight : dynamicHeight;
      if ($jsSlideShowVideo.length) {
        $jsSlideShowVideo.find('video').css('max-height', maxHeight);
      }
      if ($imageParentEl.length) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slides__pdp-vid').find('video').css('max-height', maxHeight);
      }
    };
    var productImageView = function productImageView() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slides').slides({
        adaptiveHeight: true,
        nextArrow: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slides').find('.slick-next'),
        prevArrow: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slides').find('.slick-prev'),
        showZoomTab: true,
        lazyLoad: 'progressive',
        // switched to progressive because of adaptiveHeight
        asNavFor: '.js-primary-slideshow__pager',
        dots: false,
        waitForAnimate: false
      });
      var SELECTORS = {
        GALLERY_CONTAINER: '.js-slides--two-column',
        GALLERY_SLICK: '.js-slides--two-column-slick',
        GALLERY_SLICK_VIDEOS: '.js-slides--two-column-slick video:not(.ab3461)',
        GALLERY_NAV_CONTAINER: '.js-slides--two-column-nav',
        GALLERY_NAV_SLICK: '.js-slides--two-column-nav-slick'
      };
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.ab3461').length) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.ab3461').trigger('play');
        makeAutoplayVideosAccessible();
      }

      // apply custom video players to videos
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_SLICK_VIDEOS).customVideoPlayer();
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_CONTAINER).length) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_SLICK).removeClass('u-flex');
        if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_SLICK).hasClass('slick-initialized')) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_CONTAINER).slides({
            slidesToShow: getGallerySlidesToShow(),
            slidesToScroll: 1,
            adaptiveHeight: false,
            arrows: true,
            showZoomTab: true,
            lazyLoad: 'progressive',
            dots: false,
            rtl: rtlBool,
            waitForAnimate: false,
            nextArrow: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_CONTAINER).find('.slick-next'),
            prevArrow: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_CONTAINER).find('.slick-prev'),
            asNavFor: SELECTORS.GALLERY_NAV_SLICK
          });
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_NAV_SLICK).on('init', function () {
            if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-cotton-seal').length) {
              __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-cotton-seal').show();
            }
          });
          var navItemCount = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_NAV_SLICK).find('.slideshow--gallery__nav-item').length;
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_NAV_CONTAINER).slides({
            asNavFor: SELECTORS.GALLERY_SLICK,
            dots: false,
            focusOnSelect: true,
            slidesToShow: Math.max(navItemCount, 1),
            infinite: false,
            slidesToScroll: 1,
            waitForAnimate: false,
            adjacentSlidesBorder: true,
            arrows: false,
            rtl: rtlBool
          });
        }
        makeAutoplayVideosAccessible();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_SLICK).on('beforeChange', function (_, slick, currentSlide, nextSlide) {
          var $slickElCurrent = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(slick.$slides.get(currentSlide));
          var $slickElNext = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(slick.$slides.get(nextSlide));
          // const $slickVid = $slickEl.find('video');
        });
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_SLICK).on('afterChange', function (_, slick) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(slick.$slides).each(function () {
            var $slide = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
            var $slideVid = $slide.find('video');
            if (!$slideVid.length || $slide.find('.ab3461').length) return;
            if ($slide.hasClass('slick-active')) {
              $slideVid.trigger('play');
            } else {
              $slideVid.trigger('pause');
            }
          });
        });
        if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.slideshow--gallery__nav-item').length >= 2) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_CONTAINER).find('.slick-next').removeClass('u-hide');
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_CONTAINER).find('.slick-prev').removeClass('u-hide');
        } else {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.slideshow--gallery__nav').addClass('u-hide');
        }
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_SLICK_VIDEOS).on('play', function () {
          var $thisVid = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(SELECTORS.GALLERY_SLICK_VIDEOS).each(function () {
            var $otherVid = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
            if (!$thisVid.is($otherVid)) {
              $otherVid.trigger('pause');
            }
          });
        });
      }
      function makeAutoplayVideosAccessible() {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.ab3461').each(function () {
          var $video = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
          $video.attr({
            'aria-label': 'Product demonstration video, playing automatically',
            'role': 'img'
          });
        });
      }
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slides__pdp-vid').on('beforeChange', function (_, slick, currentSlide, nextSlide) {
        var $slickEl = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(slick.$slides.get(nextSlide));
        if (nextSlide !== currentSlide) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slideshow__vid video:not(.ab3461)').each(function (i, item) {
            item.pause();
          });
        }
        var $videoPlayBtn = $slickEl.find('.js-slideshow__vid-play-btn');
        var $videoWrapper = $slickEl.find('.js-slideshow__vid');
        if ($videoPlayBtn.length > 0) {
          $videoWrapper.css('display', 'flex'); // adds flex to video due to border
          $videoPlayBtn.click();
        }
        getImageHeight();
      });
    };
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).on('init resize', function () {
      getImageHeight();
    });
    productImageView();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('div.zoomWindow').remove();
    initColorSwatchesJs();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#special-order").click(function () {
      showSOPopup(this);
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-toggle-change').toggleChange();
    var $stylSlideImg = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#js-stylitics-slideshow-image');
    var $stylImageContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-main-stylitics-image-container');
    var $slideImageContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-main-default-image-container');
    var styliticsProduct = '';
    var styliticsRelatedProduct = '';
    var styliticsSrcTag = '';
    $stylImageContainer.on('click', function () {
      loadQuickViewForProducts(styliticsProduct, styliticsRelatedProduct.split(','), styliticsSrcTag);
    });
    var zoomModalSettings = {
      type: 'full',
      onPrepend: function onPrepend() {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-floating-video-button video').each(function () {
          if (!this.paused) this.pause();
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'pdp zoom modal', 'open zoom', 'PDP clicking on/opening zoom modal');
        var windowWidth = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).width();
        var shouldShowTwoImages = windowWidth > 1190;
        var thumbCount = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-full-view-thumb .slideshow__pager-thumb').length <= 2;
        var $slickThumbs = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-full-view-thumb');
        var $navArrows = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.slideshow__nav');
        if (shouldShowTwoImages && thumbCount) {
          $slickThumbs.hide();
          $navArrows.hide();
        }
      },
      onClose: function onClose() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'pdp zoom modal', 'exit zoom', 'PDP zoom model closed');
      }
    };
    var $mainGallery = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slides-slick');
    var adjustedIndex;
    $mainGallery.on('mouseup', function (e) {
      var $li = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).closest('.slick-slide');
      var slickIndex = $li.data('slick-index');
      // Find the leftmost visible slide in the current view
      // Check if there's a slide to the left that's also visible
      var $leftSibling = $li.prev('.slick-slide:not(.slick-cloned)').filter('.slick-active');
      adjustedIndex = $leftSibling.length ? $leftSibling.data('slick-index') : slickIndex;
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-primary-slideshow-wrapper .js-zoom-modal').on("click", function () {
      var fullViewUrl = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#primary-slideshow-btn').data('url');
      var currentSlide = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-primary-slideshow__pager-thumb.active').data('slide');
      adjustedIndex = Number(currentSlide);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal(_objectSpread(_objectSpread({}, zoomModalSettings), {}, {
        url: fullViewUrl,
        triggerOpen: true,
        onComplete: function onComplete() {
          fullProductImageView(adjustedIndex);
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-full-view .slideshow__image').removeClass('u-hide');
        }
      }));
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slides--two-column .js-zoom-modal').modal(_objectSpread(_objectSpread({}, zoomModalSettings), {}, {
      triggerByClick: false,
      onComplete: function onComplete() {
        fullProductImageView(adjustedIndex);
      }
    }));
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slideshow__vid-play-btn').on('click', function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).addClass('u-hide');
      var video = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).closest('.js-slideshow__vid').find('video');
      video[0].play();
    });
    var rcProps = window.rcProps || {};
    // Add to my list
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-my-list').on('click', function () {
      var productCode = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('code');
      if (typeof __WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */] === 'function') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP', 'click', 'PDP add to my list clicked');
      }
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
        url: window.rcProps.hearts.addToMyListsModalHref,
        data: {
          code: productCode
        },
        type: 'small',
        triggerOpen: true,
        returnFocus: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-toggle-change').toggleChange();
          if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-my-list-body').height() >= 320) {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-my-list-body').css('border-bottom', 'thin solid #e4e4e4');
          }
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-my-list-added').on('click', function () {
            var lists = "";
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-checkbox-saved-list').each(function (i, e) {
              if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(e).is(':checked')) {
                lists += "&lists=" + __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e).data('id');
              }
            });
            if (lists === "") {
              if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-create-list-input').is(':visible') && __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#new-list').val().trim() == "") {
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#creatNewListError').html('Please enter a list name');
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-create-list-input').find('div.field').addClass('is-error');
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#new-list').on('keypress', function () {
                  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-create-list-input').find('div.field').removeClass('is-error');
                });
                return;
              } else if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-checkbox-saved-list').length === 0 && !__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-create-list-input').is(':visible')) {
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#list-not-created-error').removeClass('u-hide');
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-checkbox-saved-list').on('click', function () {
                  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#list-not-created-error').addClass('u-hide');
                });
                return;
              } else if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-checkbox-saved-list').length > 0 && !__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-create-list-input').is(':visible')) {
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#no-list-selected-error').removeClass('u-hide');
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-checkbox-saved-list').on('click', function () {
                  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#no-list-selected-error').addClass('u-hide');
                });
                return;
              }
            }
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
              url: window.rcProps.hearts.addProductToListHref + "?product=" + productCode + "&newListName=" + __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#new-list').val() + lists,
              type: "POST",
              success: function success(returnData) {
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-create-list-input').find('div.field').removeClass('is-error');
                if (returnData.errorMessage) {
                  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#creatNewListError').html(returnData.errorMessage);
                  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-create-list-input').find('div.field').addClass('is-error');
                } else {
                  if (typeof __WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */] === 'function') {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP My List', 'Product added', 'Product added to list');
                  }
                  __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
                    url: window.rcProps.hearts.addToMyListConfirmModalHref + "?product=" + productCode + '&d=' + rcProps.siteDepartment + "&newListName=" + __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#new-list').val() + lists,
                    type: 'small',
                    triggerOpen: true
                  });
                }
              }
            });
          });
        }
      });
    });

    //star rating scale for pdp review modal
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#pdp-review-modal .js-rating-scale").ratingScale({
      titleSelector: '.form-section__title'
    });
    initSizeJs();

    //heart product button
    if (window.bindHeartEvent) {
      window.bindHeartEvent(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-product-info .js-favorite-button"));
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-toggle-row").toggleRow();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-alt-view-video').on('click', function () {
      var module = "PDP ".concat(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('videoLocation'));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, module, 'Video Click', __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('videoId'));
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#addtobagbutton, #addtobagbutton_preorder').addToBag();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#buynowbutton').addBuyNow();
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.card--multiple-models').length) {
      initializeMultipleModels();
    }
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#details-markup-holder').html().trim().length === 0) {
      insertStylisticsByAjax();
    }
    if (window.rcProps.revieveEventEnabled) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__modules_revieve_try_on__["b" /* revieveTryOn */])();
    } else {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).on('revieveScriptLoaded', function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__modules_revieve_try_on__["b" /* revieveTryOn */])();
      });
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__modules_revieve_makeup_advisor__["a" /* revieveMakeupAdvisor */])();
    getInfluencerMarkup();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__modules_social_proof__["c" /* renderPdpSocialProof */])(window.rcProps.pdp.code);
  }
  function getInfluencerMarkup() {
    if (rcProps.influencerShareLinkHref) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.get(rcProps.influencerShareLinkHref, function (data) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#social-influencer-share-link').html(data);
      });
    }
    if (rcProps.influencerShareBannerHref) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.get(rcProps.influencerShareBannerHref, function (data) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#social-influencer-share-banner').html(data);
      });
    }
  }

  // For multiple models A/B test https://revolve.atlassian.net/browse/AB-632
  // NOTE: Adding a variable to the outer scope to keep track of current model.
  var currentModelCount = -1;
  function initializeMultipleModels() {
    var $sizeEl = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.card--multiple-models__size');
    var $heightEl = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.card--multiple-models__height');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-model-switch').on('click', function () {
      var _$$data = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data(),
        modelCount = _$$data.modelCount,
        modelHeight = _$$data.modelHeight,
        modelSize = _$$data.modelSize,
        totalModelNum = _$$data.totalModelNum,
        modelNum = _$$data.modelNum;
      var logData = {
        modelHeight: modelHeight,
        modelSize: modelSize,
        modelNum: modelNum
      };

      // Prevent further execution if user clicks on currently selected model
      if (parseInt(modelCount) === currentModelCount) {
        return;
      }
      currentModelCount = modelCount;
      $sizeEl.text(modelSize);
      $heightEl.text(modelHeight);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#model-".concat(modelCount, "-images")).show();
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).attr('id') !== "tab-".concat(modelCount)) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#tab-".concat(modelCount)).click();
      }
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).attr('id') !== "ctl-model-tab-".concat(modelCount)) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#ctl-model-tab-".concat(modelCount)).click();
      }
      for (var i = 1; i <= totalModelNum; i++) {
        if (i !== modelCount) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#model-".concat(i, "-images")).hide();
        }
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP Change Model', 'Size Change', JSON.stringify(logData));
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slides--two-column-slick:visible, .js-slides--two-column-nav-slick:visible').slick('setPosition');
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.multiple-models-2-column').length <= 0) {
        swapMainImage(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.slideshow__pager-thumb').first());
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#model-".concat(modelCount, "-images > button")).first().trigger('mouseenter');
        var fullViewUrl = fullViewPath + "&".concat(currentModelCountParam, "=").concat(modelNum);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#primary-slideshow-btn').data('url', fullViewUrl);
      }
    });
  }
  function updateSizeData() {
    var opts = Object.assign({}, __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.product-sizes').data());
    var productCodes = opts.productCodes ? opts.productCodes.split(',') : [];
    if (productCodes.length) {
      if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isEmptyObject(window.rcProps.productData)) {
        applySizeData(opts, window.rcProps.productData, productCodes);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
          type: 'GET',
          url: '/r/ajax/GetProductData.jsp',
          data: {
            product: productCodes,
            department: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#header-jsp').data('department')
          },
          success: function success(rtn) {
            window.rcProps.productData = rtn;
            applySizeData(opts, rtn, productCodes);
          }
        });
      }
    }
    if (opts.preselectedSize) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#sizeValue').val(opts.preselectedSize);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#size-options-".concat(opts.preselectedSizeId)).click();
    } else if (opts.isOneSize) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#size-options-one-size').click();
    } else {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#size-options-no-size').click();
    }
  }
  function applySizeData(opts, data, productCodes) {
    var productCode = window.rcProps.pdp.code;
    var isOneSize = opts.isOneSize;
    var useRealTimeInventory = opts.realTimeInventory;
    var jsonData = parseRtn(data);
    var productData = jsonData[productCode];
    var sizes = productData.inventory;
    var otherCodesOutOfStockBySize = sizes.reduce(function (result, item) {
      result[item['size']] = [];
      return result;
    }, {});
    for (var i = 0; i < productCodes.length; i++) {
      // figure out which codes are OOS (default to available to prevent incorectly marking as OOS)
      var colorwayCode = productCodes[i];
      if (colorwayCode === productCode) {
        // current PDP separately handles the sizes so no need to process here
        continue;
      }
      if (jsonData[colorwayCode]) {
        var colorwaySizes = jsonData[colorwayCode].inventory;
        if (colorwaySizes) {
          for (var j = 0; j < colorwaySizes.length; j++) {
            var colorwaySize = colorwaySizes[j];
            var oos = colorwaySize.quantity === 0;
            if (oos) {
              var sizesOos = otherCodesOutOfStockBySize[colorwaySize.size];
              if (sizesOos) {
                sizesOos.push(colorwayCode);
              }
            }
          }
        }
      }
    }
    var sizeOptionsObj = {};
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-size-option').each(function () {
      sizeOptionsObj[this.id] = false;
    });
    for (var _i = 0; _i < sizes.length; _i++) {
      var size = sizes[_i];
      var sizeValue = isOneSize ? 'one-size' : size.size;
      var price = size.priceAmount ? size.priceAmount : productData.priceAmount;
      var priceFormatted = size.price ? size.price : productData.price;
      var retailPrice = size.retailPriceAmount ? size.retailPriceAmount : productData.retailPriceAmount;
      var retailPriceFormatted = size.retailPrice ? size.retailPrice : productData.retailPrice;
      var id = "size-options-".concat(isOneSize ? 'one-size' : size.sizeForId);
      var input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#".concat(id));
      if (input) {
        var nowDisabled = size.quantity <= 0;
        input.data('colorsOos', otherCodesOutOfStockBySize[sizeValue]);
        if (useRealTimeInventory) {
          // only change these data attributes if using cached sizes for PDP
          input.data('code', size.code).data('qty', size.quantity).data('isPreorder', size.preOrderOnly).data('price', price).data('priceFormatted', priceFormatted).data('regularPrice', retailPrice).data('regularPriceFormatted', retailPriceFormatted).data('onSale', price < retailPrice).data('finalSale', size.disclaimer && size.disclaimer.indexOf('FINAL SALE') > -1).data('inventoryDisclaimer', size.disclaimer);
          input.prop('disabled', nowDisabled);
          delete sizeOptionsObj[id];
        }
        if (isOneSize || input.is(':checked')) {
          // (e.g., pre-selected size that can now indicate OOS for other colorways)
          input.click();
        }
      }
    }
    if (useRealTimeInventory) {
      for (var key in sizeOptionsObj) {
        // disable any sizes that weren't processed
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#".concat(key)).prop('disabled', true);
      }
    }
  }
  function getLazyLoadSizeModule() {
    if (!rcProps.hasOwnProperty('lazyLoadSizeModule')) {
      return false;
    }
    var dataForSizeModule = {
      productCode: rcProps.lazyLoadSizeModule.productCode,
      fpCode: rcProps.lazyLoadSizeModule.fpCode,
      sectionUrl: rcProps.lazyLoadSizeModule.sectionUrl,
      cantFindSizeText: rcProps.lazyLoadSizeModule.cantFindSizeText,
      showSizePopup: rcProps.lazyLoadSizeModule.showSizePopup
    };
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
      type: 'GET',
      url: rcProps.lazyLoadSizeModule.path,
      data: dataForSizeModule,
      success: function success(rtn) {
        var _sizeMarkupDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#lazy-load-size-module');
        if (rtn && rtn.sizeMarkup && _sizeMarkupDiv.length) {
          _sizeMarkupDiv.html(rtn.sizeMarkup);
          updateSizeData();
          initSizeJs();
          runFitPredictor();
          if (typeof window.placeTangibleeCta === 'function') {
            window.placeTangibleeCta();
          }
        }
      },
      error: function error() {
        console.error('An error about lazyloading sizes has occurred');
      }
    });
  }
  function showFullPopup(elem) {
    var data = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
      allSize: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("allSize"),
      isAllPreorder: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("isAllPreorder"),
      oosSize: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("oosSize"),
      sectionURL: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("sectionurl"),
      code: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("code"),
      sizeSelected: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("sizeSelected")
    });
    var rcProps = window.rcProps || {};
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
      url: rcProps.backInStockSpecialOrderHref,
      data: data,
      triggerOpen: true,
      returnFocus: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem),
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-progressive-button').progressiveButton();
      }
    });
  }
  function showNotifyMePopup(elem) {
    var data = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
      allSize: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("allSize"),
      isAllPreorder: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("isAllPreorder"),
      oosSize: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("oosSize"),
      sectionURL: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("sectionurl"),
      code: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("code"),
      d: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("dept"),
      sizeSelected: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("sizeSelected")
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#modal').remove();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
      url: "/r/dialog/BackInStockPopup.jsp",
      data: data,
      type: 'small',
      triggerOpen: true,
      returnFocus: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem),
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-progressive-button').progressiveButton();
      }
    });
  }
  function showSOPopup(elem) {
    var data = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
      allSize: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("allSize"),
      oosSize: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("oosSize"),
      code: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("code"),
      d: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("dept"),
      sizeSelected: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("sizeSelected")
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
      url: "/r/dialog/SpecialOrderPopup.jsp",
      data: data,
      type: "small",
      triggerOpen: true,
      returnFocus: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem)
    });
  }
  function colorClicked(code, url, size) {
    if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isEmptyObject(window.rcProps.colorSwatchData) && !__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isEmptyObject(window.rcProps.colorSwatchData[code])) {
      applyColor(window.rcProps.colorSwatchData[code], code, url, size);
    } else {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
        type: "POST",
        url: "/content/product/getMarkup/" + code,
        data: __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
          originalPlpSrc: window.rcProps.pdp.plpSrc,
          originalRef: window.rcProps.pdp.ref
        }),
        success: function success(result) {
          window.rcProps.colorSwatchData = window.rcProps.colorSwatchData || {};
          window.rcProps.colorSwatchData[code] = result;
          applyColor(result, code, url, size);
        }
      });
    }
  }
  function applyColor(result, code, url, size) {
    if (result.success && result.markup) {
      window.rcProps.pdp.code = code;
      var selectedSize;
      var isSwatchListView = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#viewToggle').prop('checked');
      // Save scroll position before replacing markup — #product-swatches is itself
      // inside the markup that .html() replaces below, so it has to be read first.
      var swatchListScrollTop = isSwatchListView ? __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#product-swatches').scrollTop() || 0 : 0;

      //js-modal moves this out of the markup that gets replaced
      var markup = result.markup;
      if (isSwatchListView) {
        markup = markup.replaceAll("product-swatches u-margin-t--none js-ct-swatches", "product-swatches u-margin-t--none js-ct-swatches product-swatches--list");
        markup = markup.replaceAll("product-swatches__name js-tooltip-content tooltip__content tooltip__content--top tooltip__content--top--sm", "product-swatches__name js-tooltip-content");
        markup = markup.replaceAll("data-ct-toggle-class", "checked data-ct-toggle-class");
      }
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#pdp-review-modal").remove();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-product-info").html(markup);

      // Restore swatch list scroll position and focus selected radio.
      // Keep this synchronous with the .html() above — deferring to rAF or setTimeout
      // lets the scrollTop=0 reset paint, which is the visible jump we're fixing.
      if (isSwatchListView) {
        var $swatchList = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#product-swatches');
        if (swatchListScrollTop) {
          $swatchList.scrollTop(swatchListScrollTop);
        }
        var selectedRadio = $swatchList.find(".js-product-swatch[data-swatch-code=\"".concat(code, "\"] .product-swatches__radio"))[0];
        if (selectedRadio) {
          selectedRadio.focus({
            preventScroll: true
          });
        }
      }
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".size-options__item").each(function (_index, el) {
        var sizeOption = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).find("input[type=radio]");
        if (sizeOption && size === sizeOption.val() && !sizeOption.prop('disabled') && sizeOption.data('qty') !== 0) {
          selectedSize = sizeOption;
        }
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".size-options__item").css("opacity", 0).animate({
        opacity: 1
      }, 800);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-product-full-view-container").html(result.fullViewImages);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__customer_reviews__["a" /* default */])({}, 1);
      initPDPJs();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".product-swatches--collapse").productSwatches();
      if (selectedSize && typeof selectedSize !== 'undefined') {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selectedSize).trigger("click");
      }

      // reload similar items
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#you-may-also-like").length) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.get("/content/product/pdp-content/".concat(code, "/similarItems"), {}, function (result) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#you-may-also-like").empty().append(result);
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-lazy-image').lazy();
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-toggle-reveal").toggleReveal();
        });
      }
      if (url) {
        insertPageTrackWithInfo(url, true, window.location.href);
        window.history.replaceState({
          code: code,
          colorClicked: true
        }, result.title, url);
        document.title = result.title;
      }

      // check if favorite state should be adjusted based on actions since retrieved
      var $heartButton = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-info .js-favorite-button');
      if (window.productHearts && window.productHearts.hasOwnProperty(code) && $heartButton.length) {
        var favoriteActiveClass = window.rcProps && window.rcProps.favoriteActiveClass;
        if (window.productHearts[code]) {
          $heartButton.addClass(favoriteActiveClass);
          $heartButton.attr('aria-checked', true);
        } else {
          $heartButton.removeClass(favoriteActiveClass);
          $heartButton.attr('aria-checked', false);
        }
      }
    } else {
      if (result.error) {
        console.log(result.error);
      } else {
        //recaptcha, do nothing for now
      }
    }
  }
  function preloadColors() {
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-product-swatch").toArray().every(function (li) {
      return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(li).data('useAjax');
    })) {
      window.rcProps = window.rcProps || {};
      window.rcProps.colorSwatchData = {};
      window.rcProps.productData = {};
      var codes = [];
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-product-swatch").each(function (idx, li) {
        var code = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(li).data("swatchCode");
        codes.push(code);
      });
      if (codes.length > 0) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
          type: "POST",
          url: "/content/product/getMarkup/",
          data: __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
            originalPlpSrc: window.rcProps.pdp.plpSrc,
            originalRef: window.rcProps.pdp.ref,
            codes: codes
          }),
          success: function success(result) {
            codes.forEach(function (code) {
              if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isEmptyObject(result[code])) {
                window.rcProps.colorSwatchData[code] = result[code];
              }
            });
          }
        });
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
          type: 'GET',
          url: '/r/ajax/GetProductData.jsp',
          data: {
            product: codes,
            department: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#header-jsp').data('department')
          },
          success: function success(rtn) {
            window.rcProps.productData = rtn;
          }
        });
      }
    }
  }
  function initColorSwatchesJs() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-swatch').on('mouseover', function () {
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('div.zoomWindow').length) {
        var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        var $colorSwatch = $this.attr('data-color-name');
        changePDPColorText($colorSwatch);
        swapMainImage($this);
      }
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-swatch').on('mouseout', function () {
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('div.zoomWindow').length) {
        revertSelectedPDPColorText();
        var $activePrimaryThumb = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-primary-slideshow__pager-thumb.active');
        swapMainImage($activePrimaryThumb);
      }
    });
    function colorSwatchSwap(elem) {
      var url = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("swatch-url");
      var size = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('input[name="size-options"]:checked').val();
      var sizeVal = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#sizeValue').val();
      if (sizeVal && sizeVal != undefined) {
        url += (url.indexOf('?') >= 0 ? '&' : '?') + __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
          sizeVal: sizeVal
        });
      }
      if (size && typeof size !== 'undefined') {
        url += (url.indexOf('?') >= 0 ? '&' : '?') + __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
          size: size
        });
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        if (urlParams.get('sizeSelected') === 'true') {
          url += (url.indexOf('?') >= 0 ? '&' : '?') + __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
            sizeSelected: true
          });
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#viewToggle').prop('checked')) {
        url += (url.indexOf('?') >= 0 ? '&' : '?') + __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
          swatchListView: true
        });
      } else {
        url = url.replace(/[?&]swatchListView=true/, '');
      }
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("use-ajax")) {
        colorClicked(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).data("swatch-code"), url, size);
      } else {
        document.location.href = url;
      }
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-product-swatch, .js_fit_style_button").on("click", function (e) {
      colorSwatchSwap(this);
      e.preventDefault();
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-swatch, .js_fit_style_button').on('keydown', function (e) {
      if (e.keyCode === 13) {
        colorSwatchSwap(this);
      }
    });
  }
  //AB test 568 - chat window
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-chat-window').chatWindow();
  //AB test 568 - chat window

  window.colorClicked = colorClicked;
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
    //Complete the look
    var completeTheLookBlock = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-complete-the-look-block');
    var completeTheLook = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-complete-the-look');
    var discoverMore = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-discover-more');
    completeTheLook.removeClass('u-hide--visible');

    //Tablet View and Below
    __WEBPACK_IMPORTED_MODULE_13_breaky___default.a.below("tablet", function () {
      completeTheLookBlock.removeClass('block--lg');
      completeTheLookBlock.addClass('block--xl');
      discoverMore.addClass('gc');
      discoverMore.removeClass('u-overflow--hidden');

      //Add pagination that is consistent with other carousel modules on the page
      completeTheLookBlock.find('.carousel__nav-inner').children('span').wrap('<div class="btn btn--circle btn--circle--lg"></div>');
    });

    // Small-Desktop View and Above
    __WEBPACK_IMPORTED_MODULE_13_breaky___default.a.above("small-desktop", function () {
      completeTheLookBlock.removeClass('block--xl');
      completeTheLookBlock.addClass('block--lg');

      //Reset to OG pagination
      completeTheLookBlock.find('.btn--circle').children('span').unwrap();
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-yt-slideshow__vid-play-btn').on('click', function () {
      var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
      var videoDivUrl = $this.parent().data('video-url');
      var modalIframeVideoId = '#js-modal-iframe-video';
      var playBtnId = $this.attr('id');
      // open ajax video modal
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
        url: "/content/video/beauty/modal",
        video: true,
        data: __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
          videoId: $this.data("videoId")
        }),
        triggerOpen: true,
        onComplete: function onComplete() {
          var yt = videoDivUrl.includes('youtube.com');
          var command;
          if (yt) {
            command = {
              "event": "command",
              "func": "playVideo",
              "args": ""
            };
          } else {
            command = {
              "method": "play",
              "value": "true"
            };
          }
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()(modalIframeVideoId).on('load', function () {
            // play video once iframe is loaded
            videoStatus(modalIframeVideoId, command);
          });
        },
        onClose: function onClose() {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slideshow-iframe').each(function () {
            var yt = {
              "event": "command",
              "func": "pauseVideo"
            };
            var vimeo = {
              "method": "pause",
              "value": "true"
            };
            videoStatus(this, yt);
            videoStatus(this, vimeo);
          });
        },
        returnFocus: "#".concat(playBtnId)
      });
    });
    function ifVideoMedia(el) {
      // if media is video
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).data('media') == 'video') {
        var $vertical = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).data('vertical');
        var $videoURL = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).data('video-url');
        var $iframeSRC = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('iframe[src="' + $videoURL + '"]');
        var isInternalVideo = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).data('is-internal-video');
        if ($vertical) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.video-modal').addClass('video-modal--vertical');
        } else {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.video-modal').removeClass('video-modal--vertical');
        }
        if ($iframeSRC.length == 0 && !isInternalVideo) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.slideshow__vid-container').append('<iframe class="js-track-video js-slideshow-iframe slideshow__vid" data-event-category="Camila Coelho" src="' + $videoURL + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-track-video').trackVideo();
        }
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#beauty-video-' + __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).data('videoCount')).css('display', 'flex'); // sets video to flex due to border issues
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-zoom-modeal-control').hide();
        // if media is image
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-zoom-modeal-control').show();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slideshow__vid-control').hide();
      }
    }
    function showVideo(el) {
      // hide all videos
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slideshow__vid-control').hide();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-slideshow-iframe').hide();
      // $('.js-main-stylitics-image-container').addClass('u-hide');
      ifVideoMedia(el);
    }

    // video in pdp
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.slideshow__pager-thumb').on('mouseenter', function () {
      showVideo(this);
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#js-primary-slideshow__pager button').on('keyup', function (event) {
      var keycode = event.keyCode ? event.keyCode : event.which;
      if (keycode == '13') {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).mouseenter();
      }
    });
    function videoStatus(selector, command) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector)[0].contentWindow.postMessage(JSON.stringify(command), '*');
    }
  });
  var colorsContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#colors-container');
  if (colorsContainer.data("ajax")) {
    var colorSwatchesParams = {
      code: window.rcProps.pdp.code
    };
    if (new URLSearchParams(window.location.search).get('swatchListView') === 'true') {
      colorSwatchesParams.swatchListView = true;
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.get(window.rcProps.pdp.colorSwatchesUri + "?" + __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param(colorSwatchesParams)).then(function (markup) {
      colorsContainer.html(markup);
      initColorSwatchesJs();
      // Swatches arrive after the global/initPDPJs plugin inits have run, so wire up the
      // grid/list toggle and tooltips on the injected markup
      colorsContainer.find('.js-toggle-change').toggleChange();
      colorsContainer.find('.js-tooltip').tooltip();
    });
  }
  var styleExpertBannerContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-style-expert-container');
  if (styleExpertBannerContainer.is('[data-ajax]')) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.get(window.rcProps.pdp.styleExpertBannerUri + "?code=" + window.rcProps.pdp.code).then(function (markup) {
      styleExpertBannerContainer.html(markup);
    });
  }
  initPDPJs();
  if (rcProps.hasOwnProperty('lazyLoadSizeModule')) {
    getLazyLoadSizeModule();
  } else {
    updateSizeData();
    runFitPredictor();
  }
  preloadColors();
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#recently-viewed, #recommended-for-you, #you-may-also-like, #you-may-also-like-fs, .js-discover-more-ab').lazyAjax({
    afterLoad: function afterLoad($el) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-tabs', $el).tabs();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-toggle-reveal", $el).toggleReveal();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-carousel', $el).slickSlider({
        responsive: [{
          breakpoint: 899,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }]
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-lazy-image').lazy();
      $el.css('aspect-ratio', '');
    },
    onFinishedAll: function onFinishedAll() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-similar-items').removeClass('product-sections__similar-items');
    }
  });
  if (rcProps.abtests.personalizedPla) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click', '.js-personalized-pla-tag', function (event) {
      var tag = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('personalized-pla-tag');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP Similar Items', 'Discover More click', tag);
      if (tag && tag.toString().trim() !== '') {
        var params = new URLSearchParams(window.location.search);
        params.set("selectedPlaTag", tag); // safely adds/updates
        window.history.pushState({}, '', "".concat(window.location.pathname, "?").concat(params.toString()));
      }
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click', '.js-personalized-pla-more', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var productCode, container, tag, index, url, res, html, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            productCode = document.querySelector('.js-personalized-pla-container').dataset.personalizedPlaCode;
            container = document.querySelector('.js-personalized-pla-tagged-tab.tabs__content--active');
            tag = container.dataset.personalizedPlaTag;
            index = container.querySelectorAll('.js-personalized-pla-tagged-tab-cell').length;
            url = new URL('/content/personalized-pla/' + productCode + '/view-more/', window.location.origin);
            url.searchParams.set('selectedPlaTag', tag);
            url.searchParams.set('index', index);
            _context.n = 1;
            return fetch(url.toString());
          case 1:
            res = _context.v;
            _context.n = 2;
            return res.text();
          case 2:
            html = _context.v;
            container.insertAdjacentHTML('beforeend', html);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error(_t);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 3]]);
    })));
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#personalized-pla').lazyAjax({
      afterLoad: function afterLoad($el) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-tabs-ab', $el).tabs();
      }
    });
  }
  function loadQuickViewForProducts(productCode, otherProductCodes, trackingTag, requestURL, callBackAfterAddToBag) {
    if (event) {
      event.preventDefault();
    }
    var data = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
      code: productCode,
      otherCodes: otherProductCodes,
      requestURL: __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.trim(requestURL) ? requestURL : window.location.href,
      callBackAfterAddToBag: callBackAfterAddToBag
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
      url: "/r/dialog/QuickView.jsp?" + data + (typeof trackingTag !== 'undefined' ? '&' + trackingTag : ''),
      type: "large",
      triggerOpen: true,
      returnFocus: '#qv-open-' + productCode,
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-carousel__qv-main').slickSlider({
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: ".js-carousel__qv-main-next",
          prevArrow: ".js-carousel__qv-main-prev",
          infinite: true
        });
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.product-swatches--collapse').productSwatches();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-toggle-row').toggleRow();
        if (window.bindHeartEvent) {
          window.bindHeartEvent(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal').find('.js-favorite-button'));
        }
        var sizeClickables = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal:visible .size-options__radio');
        autoCheckSizeOption(sizeClickables);
      }
    });
  }
  window.loadQuickViewForProducts = loadQuickViewForProducts;
  function autoCheckSizeOption(sizeClickables) {
    if (!sizeClickables || sizeClickables.length == 0) return;
    if (sizeClickables.length == 1) {
      sizeClickables.eq(0).click();
    } else if (sizeClickables.length > 1) {
      var sizeClickableCount = 0;
      var sizeToClick;
      sizeClickables.each(function () {
        if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).prop('disabled')) {
          sizeClickableCount++;
          sizeToClick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        }
      });
      if (sizeClickableCount === 1 && sizeToClick && sizeToClick.length === 1) {
        sizeToClick.click();
      }
    }
  }

  /*
      js-ctas
      =========
      CTA width is set to full if drop to more then one line
  */
  var ctaWrapHeight = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-ctas").height();
  var ctaItem = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-ctas__item");
  var ctaItemHeight = ctaItem.height();
  if (ctaWrapHeight > ctaItemHeight) {
    ctaItem.addClass("u-full-width");
    ctaItem.first().addClass('u-margin-b--lg');
  }

  /*
      Model Info Hide/Show
      Track Engagement
      ====================
  */
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-track-model-info-link').mouseover(function () {
    logEngagement(window.location.href, 'Model Info Link', 'Mouse Over');
  });
  if (window.location.href.indexOf("AddToList=true") > -1) {
    var newURL = location.href.replace("AddToList=true", "");
    window.history.pushState('object', document.title, newURL);
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('a.js-my-list').length) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('a.js-my-list').click();
    }
  }
  if (!window.rcProps.pdp.hideReviews) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__customer_reviews__["a" /* default */])({}, 1);
  }

  // Mock Changes Start
  function insertStylisticsByAjax() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
      type: 'GET',
      url: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#details-markup-holder').data('uri'),
      success: function success(data) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#details-markup-holder').append(data);
        var detailsTab = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#details-ajaxed-tab').detach();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#product-details').replaceWith(detailsTab);
        var secondaryDetails = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#secondary-tab').detach();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#product-secondary-content').replaceWith(secondaryDetails);
        // needed
        if (rtlBool) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#secondary-tab').css({
            clear: 'both',
            "float": 'left'
          });
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#secondary-tab .carousel__nav-prev').css('right', '-30px');
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#secondary-tab .carousel__nav-next').css('left', '-30px');
        }
        initialzeDetailsTabNstylisticsContainer();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-dropdown').dropdown();
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-modal').modal();
        if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.card--multiple-models').length) {
          initializeMultipleModels();
        }
        var $floatingVideoBtn = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-floating-video-button');
        if ($floatingVideoBtn.length) {
          $floatingVideoBtn.floatingVideo();
          $floatingVideoBtn.on('click', function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP Sticky Video', 'Video Click', __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('videoId'));
          });
        }
        var $employeeVideoBtn = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-emp-floating-video-button');
        if ($employeeVideoBtn.length) {
          $employeeVideoBtn.floatingVideo({
            deferUntilVisible: true
          }); // [UX-21437]
          $employeeVideoBtn.on('click', function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP Size and Fit', 'Video Click', 'productcode=' + __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('pcode'));
          });
        }
      }
    });
  }
  // Mock Changes End

  function initialzeDetailsTabNstylisticsContainer() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-product-info .js-tabs").tabs();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-accordion").accordion();
    var isAb995 = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-info .js-carousel-ctl').data('ab995');
    if (isAb995) {
      var tabletBreakpoint = window.matchMedia('(max-width: 900px)');
      var $wrap = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.pdp__cpl-wrap');
      var $slider = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-info .js-carousel-ctl'); // slickSlider initializer
      var $track = $slider.find('.js-carousel__track'); // slick element
      var $tabItems = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#details-ajaxed-tab ul').find('li');
      var $firstTabItem = $tabItems.first();
      $slider.slickSlider({
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false
      });
      var handleBreakpoint = function handleBreakpoint(e) {
        if (e.matches) {
          $wrap.css({
            visibility: 'hidden',
            display: 'block'
          });
          $track.slick('setPosition');
          $wrap.css({
            visibility: ''
          });
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-zelig-recommneded-looks').hide();
          $firstTabItem.find('a').trigger('click');
        } else {
          $wrap.css({
            visibility: '',
            display: ''
          });
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-zelig-recommneded-looks').show();
          $tabItems.eq(1).find('a')[0].click();
        }
      };
      tabletBreakpoint.addEventListener('change', handleBreakpoint);
      handleBreakpoint(tabletBreakpoint);
    } else {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-product-info .js-carousel-ctl').slickSlider({
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        responsive: [{
          breakpoint: 1020,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 900,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }]
      });
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#js-size-guide-focus-tabs').on('click touchstart', function () {
      showMeasurementGuideTabs();
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-track-sizeguide-click').click(function () {
      logEngagement(window.location.href, 'Size Guide Link', 'Click');
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-track-size-fit-tab').click(function () {
      logEngagement(window.location.href, 'Size Fit Tab', 'Click');
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".js-tabs-size-guide").tabs({
      tab: ".tabs-size-guide__link",
      tabActive: 'tabs-size-guide__link--active',
      tabContentActive: 'sizeguide-tab-content--active'
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-carousel-ctl-stylitics').slickSlider({
      slidesToShow: 2,
      slidesToScroll: 2,
      infinite: false
    });
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-shop-more-looks').length > 0) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-shop-more-looks').on('click', function () {
        var $currentFocus = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document.activeElement);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal({
          url: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('href'),
          type: 'ctl',
          method: 'get',
          triggerOpen: true,
          returnFocus: $currentFocus,
          onComplete: function onComplete(_ref3) {
            var content = _ref3.content;
            var $content = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(content);
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-carousel__shop-more').slickSlider({
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              accessiblePaging: true,
              nextArrow: $content.find(".exp__next"),
              prevArrow: $content.find(".exp__prev"),
              infinite: true,
              lazyLoad: "progressive"
            });
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-tabs').tabs();
          }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP Outfit Suggestion', 'click', '');
      });
    }
  }

  // Fit Predictor Tracking
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').on('DOMNodeInserted', '.sf-cta-wrapper', function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP Style Finder', 'Eligible Item', window.rcProps.pdp.code);
  });
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').on('click', '.fp-root', function () {
    logEngagement(window.location.href, 'Fit Predictor', 'click');
  });
  var styleFinderCode = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".sf-product-code").html();
  if (styleFinderCode) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.sf-root').click(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
        type: 'POST',
        url: '/r/ajax/LogStyleFinderEngagement.jsp',
        data: __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.param({
          code: styleFinderCode.trim()
        })
      });
    });
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_modules_influencer_share_link__["a" /* default */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__modules_revieve_try_on__["a" /* revieveAddToBag */])();
});
document.addEventListener("DOMContentLoaded", function () {
  var processed = false;
  var observer = new MutationObserver(function (mutationsList, observer) {
    if (processed) return;
    var widgetElement = document.querySelector('.yotpo-widget-instance');
    if (!widgetElement) return;
    var fullText = document.querySelector('.yotpo-bottom-line-basic-text');
    if (!fullText) return;
    processed = true;
    if (document.querySelector('.yotpo-widget-instance.ab929')) {
      var _fullText$textContent;
      var fullTextReviewNum = (fullText === null || fullText === void 0 || (_fullText$textContent = fullText.textContent.match(/[\d,]+/)) === null || _fullText$textContent === void 0 ? void 0 : _fullText$textContent[0]) || '';
      fullText.textContent = "".concat(fullTextReviewNum, " Review").concat(fullTextReviewNum !== '1' ? 's' : '');
    }
    var reviewElement = document.querySelector('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel');
    if (reviewElement) {
      // remove stars
      widgetElement.style.display = 'none';
    }
    observer.disconnect();
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
document.addEventListener('zeligWidgetLoaded', function (e) {
  handleZeligWidgetLoaded();
});
document.addEventListener('WidgetModalOpen', function (e) {
  logEngagement(window.location.href, 'Zelig', 'PDP widget clicks');
});
document.addEventListener('hue-add-to-cart', function (e) {
  var code = e.detail.variantId;
  var size;
  if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#size-ul').length) {
    size = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#size-ul li input[data-code=\"".concat(code, "\"]")).data('sizeValue');
  } else {
    size = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#sizeValue').val();
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__add_to_bag_function__["a" /* pdpAddToBag */])(null, {
    code: code,
    size: size
  });
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.hue-cart-menu-header__close').click();
});
document.addEventListener('hue-integration', function (e) {
  var detail = e.detail;
  if (detail.type === 'video-popup-open') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'hue', 'open modal', rcProps.pdp.code);
  }
});

/***/ })

},[248]);


// WEBPACK FOOTER //
// dist/pdp.js